/**
 * Collection Product Grid API - InstantSearch with Meilisearch
 * Extracted from sections/main-collection-product-grid.liquid for better maintainability
 * 
 * Supports both collection pages (CollectionGridConfig) and search pages (SearchGridConfig)
 * Requires either window.CollectionGridConfig or window.SearchGridConfig to be set before this script loads
 */
(function () {
  'use strict';

  // Get configuration from Liquid-generated config object
  // Support both collection pages and search pages
  const config = window.CollectionGridConfig || window.SearchGridConfig;
  if (!config) {
    console.error('CollectionGridConfig or SearchGridConfig not found. Make sure the config script is loaded before this file.');
    return;
  }

  // Determine if we're on a search page (global search) vs collection page
  const isSearchPage = !!window.SearchGridConfig;
  // Both pages use the same container ID for CSS compatibility
  const containerPrefix = '#product-grid-api';

  if (config.customerPricing && window.CustomerPricing) {
    window.CustomerPricing.init(config.customerPricing);
  }

  const collectionHandles = ['new-in', 'strick', 'knitwear', 'prints', 'denim', 'sale'];

  const allowedCollections = {
    // LIVE STORE
    'shirtstops': 'Shirts & Tops',
    'blouses': 'Blusen',
    'sweaterscardigans': 'Pullover & Cardigans',
    'pants': 'Hosen',
    'skirts': 'Röcke',
    'dressesjumpsuits': 'Kleider & Jumpsuits',
    'lightjacketsblazers': 'Leichte Jacken & Blazer',
    'jacketscoats': 'Jacken & Mäntel',
    'accessories': 'Accessoires',
    'shoes': 'Schuhe',

    // DEV STORE
    'shirts-tops': 'Shirts & Tops',
    // 'blouses': 'Blusen',
    // 'sweaterscardigans': 'Pullover & Cardigans'
    // 'pants': 'Hosen',
    // 'skirts': 'Röcke',
    'dresses-jumpsuits': 'Kleider & Jumpsuits',
    'lightjackets-blazers': 'Leichte Jacken & Blazer',
    'jackets-coats': 'Jacken & Mäntel',
    // 'accessories': 'Accessoires',
    // 'shoes': 'Schuhe'
  };

  // Localized collection titles from Liquid (already in current locale)
  const localizedCollectionTitles = config.localizedCollectionTitles || {};

  /**
   * Gets the collection title for a given handle
   * Uses localized title from Liquid config, falls back to allowedCollections
   * @param {string} handle - Collection handle
   * @returns {string} Localized collection title
   */
  function getCollectionTitle(handle) {
    return localizedCollectionTitles[handle] || allowedCollections[handle] || handle;
  }

  /**
   * Generates responsive image attributes for Shopify CDN images
   * Returns srcset with multiple sizes so browser can choose optimal size based on device pixel ratio
   * @param {string} imgUrl - Original image URL from Shopify CDN
   * @returns {object} Object with src, srcset, and sizes attributes
   */
  /**
   * Resize Shopify CDN image URL using query parameter format
   * This matches Shopify's image_url Liquid filter format for preload compatibility
   * @param {string} imgUrl - Original image URL
   * @param {number} width - Desired width
   * @returns {string} Resized image URL
   */
  function resizeShopifyImage(imgUrl, width) {
    if (!imgUrl || !imgUrl.includes('cdn.shopify.com')) return imgUrl;

    // Parse the URL to get base path without size suffix or query params
    // Input: https://cdn.shopify.com/.../image_400x.jpg?v=123
    // Output: https://cdn.shopify.com/.../image.jpg?width=600

    // First, separate URL from query string
    var urlParts = imgUrl.split('?');
    var pathOnly = urlParts[0];

    // Remove any existing size suffix (e.g., _400x, _400x600) using [0-9] instead of \d for compatibility
    var cleanPath = pathOnly.replace(/_[0-9]+x[0-9]*(\.[a-zA-Z]+)$/, '$1');

    // Add width query parameter (matches Shopify's image_url filter format)
    return cleanPath + '?width=' + width;
  }

  function getResponsiveImageAttrs(imgUrl) {
    if (!imgUrl || !imgUrl.includes('cdn.shopify.com')) {
      return { src: imgUrl || '', srcset: '', sizes: '' };
    }

    // Define widths for responsive images
    // Covers: mobile 1x/2x/3x, tablet 1x/2x, desktop 1x/2x/3x
    // Added 300w for better mobile coverage (150px * 2 DPR = 300w)
    var widths = [200, 300, 400, 600, 800, 1000];
    var srcsetParts = [];

    widths.forEach(function (width) {
      srcsetParts.push(resizeShopifyImage(imgUrl, width) + ' ' + width + 'w');
    });

    // Default src is 600px (good for most desktop screens)
    var defaultSrc = resizeShopifyImage(imgUrl, 600);

    // sizes: tell browser the actual display width at each breakpoint
    // Grid: 4 cols desktop, 3 cols tablet, 2 cols mobile
    // Desktop (>989px): ~440px per card (retina needs 880px → picks 1000w)
    // Tablet (750-989px): ~300px per card (retina needs 600px)
    // Mobile (<750px): ~180px per card (2 cols, 4px gap), conservative to avoid oversized images
    // Using 150px to cap at 400w even on 3x devices (150*3=450 → picks 400w)
    var sizes = '(max-width: 749px) 150px, (max-width: 989px) 300px, 440px';

    return {
      src: defaultSrc,
      srcset: srcsetParts.join(', '),
      sizes: sizes
    };
  }

  /**
   * Escapes HTML special characters in a string
   * @param {string} str - String to escape
   * @returns {string} Escaped string
   */
  function escapeAttr(str) {
    if (!str) return '';
    return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  /**
   * Builds an img tag with responsive image attributes
   * @param {string} imgUrl - Original image URL
   * @param {string} alt - Alt text
   * @param {string} className - CSS class
   * @param {string} loading - 'eager' or 'lazy'
   * @param {string} extraAttrs - Additional attributes like fetchpriority
   * @returns {string} HTML img tag
   */
  function buildResponsiveImg(imgUrl, alt, className, loading, extraAttrs) {
    var attrs = getResponsiveImageAttrs(imgUrl);
    var safeAlt = escapeAttr(alt);
    var srcsetAttr = attrs.srcset ? ' srcset="' + attrs.srcset + '"' : '';
    var sizesAttr = attrs.sizes ? ' sizes="' + attrs.sizes + '"' : '';
    return '<img src="' + attrs.src + '"' + srcsetAttr + sizesAttr + ' alt="' + safeAlt + '" class="' + className + '" loading="' + loading + '"' + (extraAttrs || '') + ' />';
  }

  // Meilisearch Configuration
  const MEILISEARCH_HOST = config.meilisearchHost;
  const MEILISEARCH_API_KEY = config.meilisearchApiKey;
  const MEILISEARCH_INDEX = config.meilisearchIndex;

  // Section settings
  const sectionId = config.sectionId;
  const productsPerPage = config.productsPerPage;
  const columnsDesktop = config.columnsDesktop;
  const showSwatch = config.showSwatch;
  const showVendor = config.showVendor;
  const collectionHandle = config.collectionHandle;
  const collectionId = config.collectionId;
  // Collection ID for Meilisearch filtering (just the numeric ID)
  const collectionGid = collectionId ? String(collectionId) : '';

  // Pagination settings
  const showPagination = config.showPagination !== false;
  const paginationType = config.paginationType || 'numbers';
  const showPaginationStats = config.showPaginationStats !== false;

  // Color hex order for dropdown sorting
  const colorOrder = [
    "#fedc41", // Yellow
    "#ef2600", // Red
    "#f898cd", // Rosa
    "#4b8fd7", // Blue
    "#44a663", // Green
    "#82541b", // Brown
    "#f3d2a8", // Sand
    "#000000", // Black
    "#b2b2b1", // Grey
    "#ffffff"  // White
  ];

  // Color hex to label mapping per language
  const colorHexLabels = {
    en: {
      "#fedc41": "Yellow",
      "#ef2600": "Red",
      "#f898cd": "Rosa",
      "#4b8fd7": "Blue",
      "#44a663": "Green",
      "#82541b": "Brown",
      "#f3d2a8": "Sand",
      "#000000": "Black",
      "#b2b2b1": "Grey",
      "#ffffff": "White"
    },
    de: {
      "#fedc41": "Gelb",
      "#ef2600": "Rot",
      "#f898cd": "Rosa",
      "#4b8fd7": "Blau",
      "#44a663": "Grün",
      "#82541b": "Braun",
      "#f3d2a8": "Sand",
      "#000000": "Schwarz",
      "#b2b2b1": "Grau",
      "#ffffff": "Weiss"
    },
    fr: {
      "#fedc41": "Jaune",
      "#ef2600": "Rouge",
      "#f898cd": "Rose",
      "#4b8fd7": "Bleu",
      "#44a663": "Vert",
      "#82541b": "Marron",
      "#f3d2a8": "Sable",
      "#000000": "Noir",
      "#b2b2b1": "Gris",
      "#ffffff": "Blanc"
    },
    it: {
      "#fedc41": "Giallo",
      "#ef2600": "Rosso",
      "#f898cd": "Rosa",
      "#4b8fd7": "Blu",
      "#44a663": "Verde",
      "#82541b": "Marrone",
      "#f3d2a8": "Sabbia",
      "#000000": "Nero",
      "#b2b2b1": "Grigio",
      "#ffffff": "Bianco"
    }
  };

  // Get current locale and color labels
  const currentLocale = config.currentLocale;
  const defaultLocale = config.defaultLocale || currentLocale;
  const colorLabels = colorHexLabels[currentLocale] || colorHexLabels['en'];

  // Helper to get localized product title
  // Meilisearch has: title (default/de), title_en, title_fr, title_it
  function getLocalizedTitle(hit) {
    if (currentLocale === 'de') {
      return hit.title || 'Product';
    }
    // Try locale-specific field first, fallback to default title
    const localizedField = 'title_' + currentLocale;
    return hit[localizedField] || hit.title || 'Product';
  }

  // Translated "Material" label
  const materialLabels = { 'en': 'Material', 'de': 'Material', 'fr': 'Matière', 'it': 'Materiale' };
  const materialLabel = materialLabels[currentLocale] || materialLabels['en'];

  // Material attribute - use language-specific facet
  const materialAttributes = { 'en': 'material_names_en', 'de': 'material_names_de', 'fr': 'material_names_fr', 'it': 'material_names_it' };
  const materialAttribute = materialAttributes[currentLocale] || materialAttributes['en'];

  // Translated "Style" label
  const styleLabels = { 'en': 'Style', 'de': 'Stil', 'fr': 'Style', 'it': 'Stile' };
  const styleLabel = styleLabels[currentLocale] || styleLabels['en'];
  const styleTranslationLocales = ['en', 'fr', 'it'];
  const styleAttribute = (currentLocale === defaultLocale || styleTranslationLocales.indexOf(currentLocale) === -1)
    ? 'style'
    : 'style_' + currentLocale;

  // Helper to get color label from hex
  function getColorLabel(hex) {
    const normalizedHex = hex.toLowerCase();
    return colorLabels[normalizedHex] || hex;
  }

  // Helper to get sort order for a color hex
  function getColorSortOrder(hex) {
    const normalizedHex = hex.toLowerCase();
    const index = colorOrder.findIndex(c => c.toLowerCase() === normalizedHex);
    return index === -1 ? colorOrder.length : index;
  }

  // Collection position sort field - uses collection ID for locale-independent sorting
  // e.g., collection ID 649347039563 becomes 'position_in_collection_id_649347039563'
  // Special case: 'all' collection should not use position sorting or collection filter
  // Also skip collection filter for search pages (global search)
  const isAllCollection = collectionHandle === 'all' || isSearchPage;
  
  // DISABLED: Collection position sorting is disabled because many collections don't have 
  // position_in_collection_id_<ID> sortable attributes in MeiliSearch, causing errors.
  // To re-enable: uncomment the line below and ensure MeiliSearch index has the position fields.
  // const collectionPositionField = (collectionId && !isAllCollection) ? 'position_in_collection_id_' + collectionId : '';
  const collectionPositionField = '';
  
  // Check if collection has randomized order enabled via metafield
  const hasRandomizedOrder = config.hasRandomizedOrder === true || config.hasRandomizedOrder === 'true';
  
  // Debug logging for randomized order
  console.log('[CollectionGrid] hasRandomizedOrder config value:', config.hasRandomizedOrder);
  console.log('[CollectionGrid] hasRandomizedOrder resolved:', hasRandomizedOrder);
  console.log('[CollectionGrid] collectionId:', collectionId);
  
  // Default sort:
  // - For randomized collections: isNew:desc, isSale:asc, release_start_time:desc, random_sort_{collectionId}:asc
  // - For non-randomized collections: variant_sort_{collectionId}:asc (primary), then isNew:desc, isSale:asc, release_start_time:desc
  // - For search pages or no collection: isNew:desc, isSale:asc, release_start_time:desc
  const defaultSortIndex = (hasRandomizedOrder && collectionId && !isSearchPage)
    ? MEILISEARCH_INDEX + ':isNew:desc,isSale:asc,release_start_time:desc,random_sort_' + collectionId + ':asc'
    : (collectionId && !isSearchPage)
      ? MEILISEARCH_INDEX + ':variant_sort_' + collectionId + ':asc,isNew:desc,isSale:asc,release_start_time:desc'
      : MEILISEARCH_INDEX + ':isNew:desc,isSale:asc,release_start_time:desc';
  
  // Get initial search query from URL for search pages
  const initialSearchQuery = isSearchPage ? (config.searchQuery || '') : '';
  
  console.log('[CollectionGrid] isSearchPage:', isSearchPage);
  console.log('[CollectionGrid] defaultSortIndex:', defaultSortIndex);
  if (isSearchPage) {
    console.log('[SearchGrid] initialSearchQuery:', initialSearchQuery);
  }

  // Track if search has been initialized (prevent multiple calls)
  var searchInitialized = false;

  function checkAndInitSearch() {
    if (searchInitialized) return true; // Already initialized, don't call again
    if (typeof instantsearch !== 'undefined' && typeof instantMeiliSearch !== 'undefined') {
      searchInitialized = true; // Set flag BEFORE calling to prevent race conditions
      startSearch();
      return true;
    }
    return false;
  }

  // Use script load events instead of polling for better performance
  function initInstantSearch() {
    // Check if already loaded (scripts may have loaded synchronously or from cache)
    if (checkAndInitSearch()) return;

    // Find the script elements and attach load listeners
    var scripts = document.querySelectorAll('script[src*="instant-meilisearch"], script[src*="instantsearch.js"]');
    var pendingScripts = scripts.length;

    if (pendingScripts === 0) {
      // Scripts not found in DOM yet, use MutationObserver as fallback
      var observer = new MutationObserver(function (mutations) {
        if (checkAndInitSearch()) {
          observer.disconnect();
        }
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });

      // Safety timeout - check periodically as backup
      var checkCount = 0;
      var safetyCheck = setInterval(function () {
        checkCount++;
        if (checkAndInitSearch() || checkCount > 50) {
          clearInterval(safetyCheck);
        }
      }, 100);
      return;
    }

    scripts.forEach(function (script) {
      if (script.complete || script.readyState === 'complete') {
        pendingScripts--;
        if (pendingScripts === 0) checkAndInitSearch();
      } else {
        script.addEventListener('load', function () {
          pendingScripts--;
          if (pendingScripts === 0) checkAndInitSearch();
        });
      }
    });
  }

  // Fallback sort index (without random_sort) for when the randomized attribute doesn't exist
  const fallbackSortIndex = MEILISEARCH_INDEX + ':isNew:desc,isSale:asc,release_start_time:desc';
  
  // Track if we've detected that random_sort is unavailable for this collection
  let randomSortUnavailable = false;

  function startSearch() {
    // Initialize Meilisearch client with finitePagination for accurate page counts
    const { searchClient: originalSearchClient } = instantMeiliSearch(MEILISEARCH_HOST, MEILISEARCH_API_KEY, {
      finitePagination: true,           // Ensures accurate nbPages instead of estimates
      paginationTotalHits: 1000         // Allow pagination up to 1000 hits (default may be too low)
    });
    
    // Wrap the search client to handle random_sort errors gracefully
    const searchClient = {
      ...originalSearchClient,
      search: async function(requests) {
        // If we already know random_sort is unavailable, replace it before searching
        let processedRequests = requests;
        if (randomSortUnavailable) {
          processedRequests = requests.map(req => {
            if (req.indexName && req.indexName.includes('random_sort_')) {
              return { ...req, indexName: fallbackSortIndex };
            }
            return req;
          });
        }
        
        try {
          return await originalSearchClient.search(processedRequests);
        } catch (error) {
          // Check if this is a "not sortable" error for random_sort
          const errorMessage = error?.message || error?.toString() || '';
          if (errorMessage.includes('random_sort_') && errorMessage.includes('is not sortable')) {
            console.warn('[CollectionGrid] random_sort attribute not available, falling back to regular sort');
            randomSortUnavailable = true;
            
            // Modify requests to use fallback sort index
            const modifiedRequests = requests.map(req => {
              if (req.indexName && req.indexName.includes('random_sort_')) {
                return {
                  ...req,
                  indexName: fallbackSortIndex
                };
              }
              return req;
            });
            
            // Retry with fallback sort
            return await originalSearchClient.search(modifiedRequests);
          }
          // Re-throw other errors
          throw error;
        }
      }
    };

    // Build the base collection filter once
    // Skip filter for 'all' collection - show all products without collection restriction
    // Use collection ID (global ID format) for locale-independent filtering
    const baseCollectionFilter = (collectionGid && !isAllCollection) ? `collections.id = "${collectionGid}"` : '';

    // Valid sort index names (without collection position sorting)
    // Include both regular and randomized default sorts for URL validation
    const validSortIndexes = [
      defaultSortIndex,
      MEILISEARCH_INDEX + ':isNew:desc,isSale:asc,release_start_time:desc', // regular default
      MEILISEARCH_INDEX + ':isNew:desc,isSale:asc', // legacy default (for backwards compatibility)
      MEILISEARCH_INDEX + ':min_price:asc',
      MEILISEARCH_INDEX + ':min_price:desc',
      MEILISEARCH_INDEX + ':isSale:asc,createdAt:desc'
    ];
    // Add randomized sort index if collection has randomized order
    if (hasRandomizedOrder && collectionId) {
      validSortIndexes.push(MEILISEARCH_INDEX + ':isNew:desc,isSale:asc,release_start_time:desc,random_sort_' + collectionId + ':asc');
    }

    // Initialize InstantSearch with custom routing that filters out invalid index names
    // This prevents errors when URL contains an old index name with collection position sorting
    const searchConfig = {
      indexName: defaultSortIndex,
      searchClient,
      routing: {
        stateMapping: {
          stateToRoute(uiState) {
            const indexUiState = uiState[Object.keys(uiState)[0]] || {};
            const route = {
              page: indexUiState.page,
              refinementList: indexUiState.refinementList,
              sortBy: indexUiState.sortBy
            };
            // Include query in URL for search pages
            if (isSearchPage) {
              route.q = indexUiState.query;
            }
            return route;
          },
          routeToState(routeState) {
            // Validate sortBy - if it contains position_in_collection_id_, use default instead
            let sortBy = routeState.sortBy;
            if (sortBy && sortBy.includes('position_in_collection_id_')) {
              console.warn('Invalid sort index in URL (contains collection position), using default');
              sortBy = defaultSortIndex;
            }
            // Also validate against known valid indexes
            if (sortBy && !validSortIndexes.includes(sortBy)) {
              console.warn('Unknown sort index in URL, using default:', sortBy);
              sortBy = defaultSortIndex;
            }
            
            // Get query from URL 'q' parameter for search pages
            const query = isSearchPage ? (routeState.q || initialSearchQuery) : undefined;
            
            return {
              [defaultSortIndex]: {
                query: query,
                page: routeState.page,
                refinementList: routeState.refinementList,
                sortBy: sortBy
              }
            };
          }
        }
      },
      insights: false
    };
    
    // Add initial UI state with search query for search pages
    if (isSearchPage && initialSearchQuery) {
      searchConfig.initialUiState = {
        [defaultSortIndex]: {
          query: initialSearchQuery
        }
      };
    }
    
    const search = instantsearch(searchConfig);

    // Format price helper
    function formatPrice(price, currency) {
      currency = currency || 'CHF';
      if (!price && price !== 0) return '';
      const numPrice = typeof price === 'string' ? parseFloat(price) : price;
      return numPrice.toFixed(2) + ' ' + currency;
    }

    // Escape HTML helper
    function escapeHtml(text) {
      if (!text) return '';
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    // Build color swatches HTML
    function buildColorSwatches(hit) {
      if (!showSwatch || !hit.all_colors || hit.all_colors.length === 0) return '';

      let html = '<div class="color-swatches">';
      hit.all_colors.forEach((color, idx) => {
        const isActive = color === hit.color_option ? ' active' : '';
        const borderStyle = color === hit.color_option ? 'border: 1px solid #1a1a1a;' : 'border: 1px solid #e9e5e1;';

        // Use color hex if available, otherwise use color name
        const bgColor = hit.color_hex && color === hit.color_option ? hit.color_hex : color.toLowerCase();

        html += `
        <span class="color-swatch${isActive}"
              title="${escapeHtml(color)}"
              style="display: inline-block; width: 20px; height: 20px; border-radius: 50%; ${borderStyle} cursor: pointer; background-color: ${bgColor};">
        </span>
      `;
      });
      html += '</div>';
      return html;
    }

    // Placeholder image URL
    const PLACEHOLDER_IMAGE = 'https://cdn.shopify.com/s/files/1/0865/6692/8715/files/product-placeholder.jpg?v=1755092870';

    // Build product images HTML with Swiper (uses responsive images)
    function buildProductImages(hit, productUrl) {
      const localizedTitle = getLocalizedTitle(hit);
      if (!hit.images || hit.images.length === 0) {
        return `<a href="${productUrl}" class="full-unstyled-link"><img src="${PLACEHOLDER_IMAGE}" alt="${escapeHtml(localizedTitle)}" class="product-img" /></a>`;
      }

      // Filter out swatch images
      const productImages = hit.images.filter(img => {
        if (!img.alt) return true;
        return !img.alt.toLowerCase().includes('swatch');
      });

      if (productImages.length === 0) {
        return `<a href="${productUrl}" class="full-unstyled-link"><img src="${PLACEHOLDER_IMAGE}" alt="${escapeHtml(localizedTitle)}" class="product-img" /></a>`;
      }

      let html = '<div class="swiper mySwiper"><div class="swiper-wrapper">';
      productImages.forEach((img, idx) => {
        const loadingAttr = idx > 0 ? 'lazy' : 'eager';
        html += `
        <div class="swiper-slide">
          <a href="${productUrl}" class="full-unstyled-link">
            ${buildResponsiveImg(img.src, img.alt || localizedTitle, 'product-img', loadingAttr, '')}
          </a>
        </div>
      `;
      });
      html += '</div>';
      html += '<div class="swiper-button-next"></div>';
      html += '<div class="swiper-button-prev"></div>';
      html += '<div class="swiper-pagination"></div>';
      html += '</div>';

      return html;
    }

    // Custom hits template
    function renderHitTemplate(hit) {
      const productUrl = '/products/' + hit.handle;
      const productTitle = getLocalizedTitle(hit);
      const price = hit.min_price || hit.max_price || 0;
      const currency = hit.currency || 'CHF';
      const formattedPrice = formatPrice(price, currency);
      const vendorHtml = showVendor && hit.vendor ? `<div class="card__vendor">${escapeHtml(hit.vendor)}</div>` : '';
      const colorSwatches = buildColorSwatches(hit);
      const imagesHtml = buildProductImages(hit, productUrl);
      const productId = hit.id || hit.product_parent_id || hit.handle;
      const variantId = hit.variants && hit.variants[0] ? hit.variants[0].id : '';

      return `
      <article class="product-card" data-product-id="${productId}" data-handle="${hit.handle}" data-variant-id="${variantId}">
        <div class="product-card__image-wrapper">
          ${imagesHtml}
        </div>
        <div class="product-card__content">
          ${colorSwatches}
          <h3 class="product-card__title">
            <a href="${productUrl}" class="full-unstyled-link">
              ${escapeHtml(productTitle)}
            </a>
          </h3>
          ${vendorHtml}
          <div class="product-card__price">
            <span class="price-item price-item--regular">
              ${formattedPrice}
            </span>
          </div>
        </div>
      </article>
    `;
    }

    // ========== SIZE GROUPING HELPERS FOR MOBILE FILTER ==========

    // Size category translations
    const sizeCategoryLabels = {
      en: { kleidung: 'Clothing', schuhe: 'Shoes', accessories: 'Accessories' },
      de: { kleidung: 'Kleidung', schuhe: 'Schuhe', accessories: 'Accessories' },
      fr: { kleidung: 'Vêtements', schuhe: 'Chaussures', accessories: 'Accessoires' },
      it: { kleidung: 'Abbigliamento', schuhe: 'Scarpe', accessories: 'Accessori' }
    };
    const sizeLabels = sizeCategoryLabels[currentLocale] || sizeCategoryLabels['en'];

    // Clothing sizes list (case-insensitive matching)
    const clothingSizes = ['xxs', 'xs', 's', 's+', 'm', 'l', 'xl', 'm|l', 'onesize', 'xs|s'];

    // Master size order for all filters (desktop dropdown and mobile)
    const sizeOrder = ['xxs', 'xs', 's', 's+', 'm', 'l', 'xl', 'm|l', 'onesize', 'xs|s', '36', '37', '38', '39', '40', '41', '43', '65cm', '70cm', '75cm', '80cm', '85cm', '90cm', '95cm', '100cm'];

    // Helper to get sort order for a size value
    function getSizeSortOrder(size) {
      const normalizedSize = size.toLowerCase();
      const index = sizeOrder.indexOf(normalizedSize);
      return index === -1 ? sizeOrder.length + normalizedSize.charCodeAt(0) : index;
    }

    // Helper to categorize size values
    function categorizeSizeValue(value) {
      const lowerValue = value.toLowerCase();
      // Check if it's a clothing size
      if (clothingSizes.includes(lowerValue)) {
        return 'kleidung';
      }
      // Check if it ends with 'cm' (accessories)
      if (lowerValue.endsWith('cm')) {
        return 'accessories';
      }
      // Check if it's a numeric value (shoes)
      if (/^\d+(\.\d+)?$/.test(value.trim())) {
        return 'schuhe';
      }
      // Default to accessories for anything else
      return 'accessories';
    }

    // Add widgets to InstantSearch
    
    // Build the widgets array - some widgets are conditional based on page type
    const widgets = [];
    
    // Configure widget - sets hits per page and collection filter (only for collection pages)
    widgets.push(
      instantsearch.widgets.configure(
        baseCollectionFilter
          ? { hitsPerPage: productsPerPage, filters: baseCollectionFilter }
          : { hitsPerPage: productsPerPage }
      )
    );
    
    // SearchBox widget - only for search pages, connected to existing input
    if (isSearchPage) {
      widgets.push(
        instantsearch.widgets.searchBox({
          container: containerPrefix + ' #search-box-widget',
          placeholder: config.translations.searchPlaceholder || 'Search...',
          showReset: false,
          showSubmit: false,
          showLoadingIndicator: false,
          cssClasses: {
            root: 'ais-SearchBox--hidden', // Hidden, we use the existing Shopify input
            input: 'ais-SearchBox-input--hidden'
          }
        })
      );
    }
    
    // Add the conditional widgets first
    if (widgets.length > 0) {
      search.addWidgets(widgets);
    }

    search.addWidgets([

      // Desktop Size refinement widget with grouped categories (Kleidung, Schuhe, Accessories)
      instantsearch.connectors.connectRefinementList(function (renderOptions, isFirstRender) {
        const { items, refine, widgetParams } = renderOptions;
        const container = document.querySelector(widgetParams.container);
        if (!container) return;

        // Group items by category
        const groups = {
          kleidung: [],
          schuhe: [],
          accessories: []
        };

        items.forEach(function (item) {
          const category = categorizeSizeValue(item.value);
          groups[category].push(item);
        });

        // Sort all size groups by master sizeOrder
        groups.kleidung.sort(function (a, b) {
          return getSizeSortOrder(a.value) - getSizeSortOrder(b.value);
        });
        groups.schuhe.sort(function (a, b) {
          return getSizeSortOrder(a.value) - getSizeSortOrder(b.value);
        });
        groups.accessories.sort(function (a, b) {
          return getSizeSortOrder(a.value) - getSizeSortOrder(b.value);
        });

        // Check if wrapper already exists (to preserve header)
        let wrapper = container.querySelector('.ais-RefinementList');
        let listContainer;
        
        if (!wrapper) {
          // First render - create wrapper structure
          wrapper = document.createElement('div');
          wrapper.className = 'ais-RefinementList';
          listContainer = document.createElement('div');
          listContainer.className = 'ais-RefinementList-list';
          wrapper.appendChild(listContainer);
          container.appendChild(wrapper);
        } else {
          // Re-render - find and update list container only
          listContainer = wrapper.querySelector('.ais-RefinementList-list');
        }

        let html = '<div class="desktop-size-groups">';

        // Render Kleidung group (4-column buttons)
        if (groups.kleidung.length > 0) {
          html += '<div class="desktop-size-group desktop-size-group--kleidung">';
          html += '<div class="desktop-size-group__label">' + sizeLabels.kleidung + '</div>';
          html += '<div class="desktop-size-group__buttons">';
          groups.kleidung.forEach(function (item) {
            const checkedClass = item.isRefined ? ' is-selected' : '';
            html += '<button type="button" class="desktop-size-btn' + checkedClass + '" data-value="' + item.value + '">' + item.label + '</button>';
          });
          html += '</div></div>';
        }

        // Render Schuhe group (4-column buttons)
        if (groups.schuhe.length > 0) {
          html += '<div class="desktop-size-group desktop-size-group--schuhe">';
          html += '<div class="desktop-size-group__label">' + sizeLabels.schuhe + '</div>';
          html += '<div class="desktop-size-group__buttons">';
          groups.schuhe.forEach(function (item) {
            const checkedClass = item.isRefined ? ' is-selected' : '';
            html += '<button type="button" class="desktop-size-btn' + checkedClass + '" data-value="' + item.value + '">' + item.label + '</button>';
          });
          html += '</div></div>';
        }

        // Render Accessories group (list with checkboxes)
        if (groups.accessories.length > 0) {
          html += '<div class="desktop-size-group desktop-size-group--accessories">';
          html += '<div class="desktop-size-group__label">' + sizeLabels.accessories + '</div>';
          html += '<ul class="desktop-size-group__list">';
          groups.accessories.forEach(function (item) {
            const checkedAttr = item.isRefined ? ' checked' : '';
            html += '<li class="desktop-size-list-item">';
            html += '<label class="desktop-size-list-label">';
            html += '<span class="desktop-size-list-text">' + item.label + '</span>';
            html += '<input type="checkbox" class="desktop-size-list-checkbox" data-value="' + item.value + '"' + checkedAttr + ' />';
            html += '</label></li>';
          });
          html += '</ul></div>';
        }

        html += '</div>';
        listContainer.innerHTML = html;

        // Add click handlers for buttons
        listContainer.querySelectorAll('.desktop-size-btn').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation(); // Prevent dropdown from closing
            const value = this.getAttribute('data-value');
            refine(value);
          });
        });

        // Add change handlers for checkboxes
        listContainer.querySelectorAll('.desktop-size-list-checkbox').forEach(function (checkbox) {
          checkbox.addEventListener('change', function (e) {
            e.stopPropagation(); // Prevent dropdown from closing
            const value = this.getAttribute('data-value');
            refine(value);
          });
        });
      })({
        container: '#size-refinement',
        attribute: 'size_options',
        limit: 50,
        showMore: false
      }),

      // Color refinement list - uses color_hex with custom labels and ordering
      instantsearch.widgets.refinementList({
        container: '#color-refinement',
        attribute: 'color_hex',
        limit: 20,
        showMore: false,
        sortBy: function (a, b) {
          // Sort by colorOrder position
          return getColorSortOrder(a.name) - getColorSortOrder(b.name);
        },
        templates: {
          item(item, { html }) {
            const label = getColorLabel(item.value);
            const hexColor = item.value;
            const isWhite = hexColor.toLowerCase() === '#ffffff';
            const swatchBorder = isWhite ? '1px solid #e0e0e0' : 'none';
            return html`
            <label class="ais-RefinementList-label">
              <span class="ais-RefinementList-colorSwatch" style="background-color: ${hexColor}; border: ${swatchBorder};"></span>
              <span class="ais-RefinementList-labelText">${label}</span>
              <input type="checkbox" class="ais-RefinementList-checkbox" value="${item.value}" checked=${item.isRefined} />
            </label>
          `;
          }
        }
      }),

      // Material refinement list - uses language-specific attribute
      instantsearch.widgets.refinementList({
        container: '#material-refinement',
        attribute: materialAttribute,
        limit: 20,
        showMore: false,
        sortBy: ['name:asc'],
        templates: {
          item(item, { html }) {
            return html`
            <label class="ais-RefinementList-label">
              <span class="ais-RefinementList-labelText">${item.label}</span>
              <input type="checkbox" class="ais-RefinementList-checkbox" value="${item.value}" checked=${item.isRefined} />
            </label>
          `;
          }
        }
      }),

      // Style refinement list - only mounted where the container exists
      // (rendered just for the allowlisted collections; absent on the search page)
      ...(document.querySelector('#style-refinement') ? [instantsearch.widgets.refinementList({
        container: '#style-refinement',
        attribute: styleAttribute,
        limit: 20,
        showMore: false,
        sortBy: ['name:asc'],
        templates: {
          item(item, { html }) {
            return html`
            <label class="ais-RefinementList-label">
              <span class="ais-RefinementList-labelText">${item.label}</span>
              <input type="checkbox" class="ais-RefinementList-checkbox" value="${item.value}" checked=${item.isRefined} />
            </label>
          `;
          }
        }
      })] : []),

      // Collections refinement list - filter by collection handle (conditionally added)
      ...(collectionHandles.includes(collectionHandle) ? [
        instantsearch.widgets.refinementList({
          container: '#categories-filter-items',
          attribute: 'collections.handle',
          limit: 70,
          showMore: false,
          sortBy: ['count:desc'],
          transformItems(items) {
            // Filter to only allowed collections and map to localized display titles
            const mapped = items
              .filter(item => allowedCollections[item.value])
              .map(item => ({
                ...item,
                label: getCollectionTitle(item.value)
              }));

            // Deduplicate by label - merge items with same display name
            const deduplicated = {};
            mapped.forEach(item => {
              if (deduplicated[item.label]) {
                // Merge: sum counts, keep refined state if any variant is refined
                deduplicated[item.label].count += item.count;
                deduplicated[item.label].isRefined = deduplicated[item.label].isRefined || item.isRefined;
              } else {
                deduplicated[item.label] = { ...item };
              }
            });

            return Object.values(deduplicated);
          },
          templates: {
            item(item, { html }) {
              return html`
                <div class="categories-filter-item">
                  <div class="item-inner">
                    <button class="button button--secondary filter-btn ${item.isRefined ? 'active-filter' : ''}">
                      ${item.label}
                    </button>
                  </div>
                </div>
              `;
            }
          }
        })
      ] : []),

      // ========== MOBILE FILTER WIDGETS ==========

      // Custom Mobile Size refinement widget with grouped categories
      instantsearch.connectors.connectRefinementList(function (renderOptions, isFirstRender) {
        const { items, refine, widgetParams } = renderOptions;
        const container = document.querySelector(widgetParams.container);
        if (!container) return;

        // Group items by category
        const groups = {
          kleidung: [],
          schuhe: [],
          accessories: []
        };

        items.forEach(function (item) {
          const category = categorizeSizeValue(item.value);
          groups[category].push(item);
        });

        // Sort all size groups by master sizeOrder
        groups.kleidung.sort(function (a, b) {
          return getSizeSortOrder(a.value) - getSizeSortOrder(b.value);
        });

        // Sort shoe sizes by master sizeOrder
        groups.schuhe.sort(function (a, b) {
          return getSizeSortOrder(a.value) - getSizeSortOrder(b.value);
        });

        // Sort accessories by master sizeOrder
        groups.accessories.sort(function (a, b) {
          return getSizeSortOrder(a.value) - getSizeSortOrder(b.value);
        });

        let html = '<div class="mobile-size-groups">';

        // Render Kleidung group (4-column buttons)
        if (groups.kleidung.length > 0) {
          html += '<div class="mobile-size-group mobile-size-group--kleidung">';
          html += '<div class="mobile-size-group__label">' + sizeLabels.kleidung + '</div>';
          html += '<div class="mobile-size-group__buttons">';
          groups.kleidung.forEach(function (item) {
            const checkedClass = item.isRefined ? ' is-selected' : '';
            html += '<button type="button" class="mobile-size-btn' + checkedClass + '" data-value="' + item.value + '">' + item.label + '</button>';
          });
          html += '</div></div>';
        }

        // Render Schuhe group (4-column buttons)
        if (groups.schuhe.length > 0) {
          html += '<div class="mobile-size-group mobile-size-group--schuhe">';
          html += '<div class="mobile-size-group__label">' + sizeLabels.schuhe + '</div>';
          html += '<div class="mobile-size-group__buttons">';
          groups.schuhe.forEach(function (item) {
            const checkedClass = item.isRefined ? ' is-selected' : '';
            html += '<button type="button" class="mobile-size-btn' + checkedClass + '" data-value="' + item.value + '">' + item.label + '</button>';
          });
          html += '</div></div>';
        }

        // Render Accessories group (list with checkboxes)
        if (groups.accessories.length > 0) {
          html += '<div class="mobile-size-group mobile-size-group--accessories">';
          html += '<div class="mobile-size-group__label">' + sizeLabels.accessories + '</div>';
          html += '<ul class="mobile-size-group__list">';
          groups.accessories.forEach(function (item) {
            const checkedAttr = item.isRefined ? ' checked' : '';
            html += '<li class="mobile-size-list-item">';
            html += '<label class="mobile-size-list-label">';
            html += '<span class="mobile-size-list-text">' + item.label + '</span>';
            html += '<input type="checkbox" class="mobile-size-list-checkbox" data-value="' + item.value + '"' + checkedAttr + ' />';
            html += '</label></li>';
          });
          html += '</ul></div>';
        }

        html += '</div>';
        container.innerHTML = html;

        // Add click handlers for buttons
        container.querySelectorAll('.mobile-size-btn').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            const value = this.getAttribute('data-value');
            refine(value);
          });
        });

        // Add change handlers for checkboxes
        container.querySelectorAll('.mobile-size-list-checkbox').forEach(function (checkbox) {
          checkbox.addEventListener('change', function (e) {
            const value = this.getAttribute('data-value');
            refine(value);
          });
        });
      })({
        container: '#mobile-size-refinement',
        attribute: 'size_options',
        limit: 50,
        showMore: false
      }),

      // Mobile Color refinement list
      instantsearch.widgets.refinementList({
        container: '#mobile-color-refinement',
        attribute: 'color_hex',
        limit: 20,
        showMore: false,
        sortBy: function (a, b) {
          return getColorSortOrder(a.name) - getColorSortOrder(b.name);
        },
        templates: {
          item(item, { html }) {
            const label = getColorLabel(item.value);
            const hexColor = item.value;
            const isWhite = hexColor.toLowerCase() === '#ffffff';
            const swatchBorder = isWhite ? '1px solid #e0e0e0' : 'none';
            return html`
            <label class="ais-RefinementList-label">
              <span class="ais-RefinementList-colorSwatch" style="background-color: ${hexColor}; border: ${swatchBorder};"></span>
              <span class="ais-RefinementList-labelText">${label}</span>
              <input type="checkbox" class="ais-RefinementList-checkbox" value="${item.value}" checked=${item.isRefined} />
            </label>
          `;
          }
        }
      }),

      // Mobile Material refinement list
      instantsearch.widgets.refinementList({
        container: '#mobile-material-refinement',
        attribute: materialAttribute,
        limit: 20,
        showMore: false,
        sortBy: ['name:asc'],
        templates: {
          item(item, { html }) {
            return html`
            <label class="ais-RefinementList-label">
              <span class="ais-RefinementList-labelText">${item.label}</span>
              <input type="checkbox" class="ais-RefinementList-checkbox" value="${item.value}" checked=${item.isRefined} />
            </label>
          `;
          }
        }
      }),

      // Mobile Style refinement list - only mounted where the container exists
      ...(document.querySelector('#mobile-style-refinement') ? [instantsearch.widgets.refinementList({
        container: '#mobile-style-refinement',
        attribute: styleAttribute,
        limit: 20,
        showMore: false,
        sortBy: ['name:asc'],
        templates: {
          item(item, { html }) {
            return html`
            <label class="ais-RefinementList-label">
              <span class="ais-RefinementList-labelText">${item.label}</span>
              <input type="checkbox" class="ais-RefinementList-checkbox" value="${item.value}" checked=${item.isRefined} />
            </label>
          `;
          }
        }
      })] : []),

      // Custom Sort By widget with menu-style rendering (renders to both desktop and mobile)
      {
        $$type: 'custom.sortByMenu',
        init({ instantSearchInstance }) {
          this.helper = instantSearchInstance.helper;
        },
        render({ helper }) {
          // Translated sort labels
          const sortLabels = {
            en: { sortBy: 'Sort by', priceAsc: 'Price Ascending', priceDesc: 'Price Descending', new: 'New' },
            de: { sortBy: 'Sortieren nach', priceAsc: 'Preis aufsteigend', priceDesc: 'Preis absteigend', new: 'Neu' },
            fr: { sortBy: 'Trier par', priceAsc: 'Prix croissant', priceDesc: 'Prix décroissant', new: 'Nouveau' },
            it: { sortBy: 'Ordina per', priceAsc: 'Prezzo crescente', priceDesc: 'Prezzo decrescente', new: 'Nuovo' }
          };
          const sortText = sortLabels[currentLocale] || sortLabels['en'];

          const sortOptions = [
            { label: sortText.sortBy, value: defaultSortIndex },
            { label: sortText.priceAsc, value: MEILISEARCH_INDEX + ':min_price:asc' },
            { label: sortText.priceDesc, value: MEILISEARCH_INDEX + ':min_price:desc' },
            { label: sortText.new, value: MEILISEARCH_INDEX + ':isSale:asc,createdAt:desc' }
          ];

          const currentIndex = helper.getIndex();

          let html = '<div class="ais-SortBy"><ul class="ais-SortBy-list">';
          sortOptions.forEach(option => {
            const isSelected = option.value === currentIndex;
            html += `<li class="ais-SortBy-item ${isSelected ? 'ais-SortBy-item--selected' : ''}" data-value="${option.value}">${option.label}</li>`;
          });
          html += '</ul></div>';

          // Render to both desktop and mobile containers
          const containers = ['sort-by', 'mobile-sort-by'];
          containers.forEach(function (containerId) {
            const container = document.getElementById(containerId);
            if (!container) return;

            container.innerHTML = html;

            // Add click handlers
            container.querySelectorAll('.ais-SortBy-item').forEach(item => {
              item.addEventListener('click', (e) => {
                const newIndex = e.target.dataset.value;
                helper.setIndex(newIndex).search();
                // Close the dropdown
                const widget = container.closest('.filter-widget');
                if (widget) widget.classList.remove('is-open');
              });
            });
          });
        }
      },

      // Hits widget with custom template
      instantsearch.widgets.hits({
        container: '#hits',
        transformItems: function(items) {
          if (window.CustomerPricing && window.CustomerPricing.isActive()) {
            return items.map(function(item) {
              var result = window.CustomerPricing.applyToHit(item);
              return result;
            });
          }
          return items;
        },
        templates: {
          item: function (hit) {
            var productTitle = getLocalizedTitle(hit);
            var price = hit.min_price || hit.max_price || hit.price || 0;
            // Try multiple field names for compare-at price
            var comparePrice = hit.compare_at_price || hit.compare_at_price_max || hit.compare_at_price_min ||
              hit.compareAtPrice || hit.compareAtPriceMax || hit.max_compare_at_price ||
              hit.original_price || hit.was_price || 0;
            var currency = hit.currency || 'CHF';
            var productId = hit.id || hit.objectID || '';
            var currentColor = hit.color_option || '';

            // Get variant ID from the active swatch (matching current color) or fallback to hit data
            var variantId = '';
            if (hit.all_swatches && Array.isArray(hit.all_swatches) && currentColor) {
              var activeSwatch = hit.all_swatches.find(function (s) { return s.color === currentColor; });
              if (activeSwatch && activeSwatch.variant_id) {
                variantId = activeSwatch.variant_id;
              }
            }
            // Fallback to hit-level variant ID if not found in swatches
            if (!variantId) {
              variantId = hit.variant_id || (hit.variants && hit.variants[0] ? hit.variants[0].id : '');
            }

            // Build product URL with variant ID
            var productUrl = '/products/' + (hit.handle || '');
            if (variantId) {
              productUrl += '?variant=' + variantId;
            }


            // Check if product has a compare-at price (different from regular price)
            var hasComparePrice = comparePrice > 0 && comparePrice > price && price > 0;

            // Format prices - currency before price (e.g., "CHF 159.00")
            var formattedPrice = currency + ' ' + (typeof price === 'number' ? price.toFixed(2) : String(price));
            var formattedComparePrice = currency + ' ' + (typeof comparePrice === 'number' ? comparePrice.toFixed(2) : String(comparePrice));

            // Build price HTML - show compare price if available
            var priceHtml = '';
            if (hasComparePrice) {
              priceHtml = '<span class="price-item--sale">' + formattedPrice + '</span>' +
                '<span class="price-item--compare">' + formattedComparePrice + '</span>';
            } else {
              priceHtml = '<span class="price-item--regular">' + formattedPrice + '</span>';
            }

            // Sale badge - only show if isSale is true
            var saleBadgeHtml = hit.isSale ? '<span class="product-badge sale-badge">Sale</span>' : '';

            // NEW badge - only show if product belongs to the NEW IN collection
            var isInNewCollection = false;
            if (hit.collections && Array.isArray(hit.collections)) {
              isInNewCollection = hit.collections.some(function (col) {
                var handle = (col.handle || col || '').toString().toLowerCase();
                return handle === 'new-in' || handle === 'new' || handle === 'newin';
              });
            }
            var newBadgeHtml = isInNewCollection ? '<span class="product-badge new-badge">New In</span>' : '';

            // Wishlist button - NileWishlist module
            var comparePriceAttr = (comparePrice && comparePrice > 0 && comparePrice > price) ? comparePrice.toFixed(2) : '';
            var wishlistProductId = productId;
            var wishlistVariantId = variantId;
            var wishlistImageUrl = '';
            if (hit.images && hit.images.length > 0 && hit.images[0].src) {
              wishlistImageUrl = hit.images[0].src;
            } else if (hit.image) {
              wishlistImageUrl = hit.image;
            }

            var wishlistHtml = '<button type="button" class="wishlist-btn wishlist-btn--grid"' +
              ' data-wishlist-add' +
              ' data-product-id="' + wishlistProductId + '"' +
              ' data-variant-id="' + wishlistVariantId + '"' +
              ' data-product-title="' + productTitle.replace(/"/g, '&quot;') + '"' +
              ' data-variant-title=""' +
              ' data-price="' + (typeof price === 'number' ? price.toFixed(2) : price) + '"' +
              ' data-compare-at-price="' + comparePriceAttr + '"' +
              ' data-image-url="' + wishlistImageUrl + '"' +
              ' data-product-handle="' + (hit.handle || '') + '"' +
              ' aria-label="Add to wishlist"' +
              ' aria-pressed="false">' +
              '<span class="wishlist-btn__icon">' +
              '<svg class="wishlist-btn__icon-empty" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1792 1792">' +
              '<path d="M1664 596q0-81-21.5-143t-55-98.5-81.5-59.5-94-31-98-8-112 25.5-110.5 64-86.5 72-60 61.5q-18 22-49 22t-49-22q-24-28-60-61.5t-86.5-72-110.5-64-112-25.5-98 8-94 31-81.5 59.5-55 98.5-21.5 143q0 168 187 355l581 560 580-559q188-188 188-356zm128 0q0 221-229 450l-623 600q-18 18-44 18t-44-18l-624-602q-10-8-27.5-26t-55.5-65.5-68-97.5-53.5-121-23.5-138q0-220 127-344t351-124q62 0 126.5 21.5t120 58 95.5 68.5 76 68q36-36 76-68t95.5-68.5 120-58 126.5-21.5q224 0 351 124t127 344z" fill="currentColor"></path>' +
              '</svg>' +
              '<svg class="wishlist-btn__icon-filled" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1792 1792">' +
              '<path d="M896 1664q-26 0-44-18l-624-602q-10-8-27.5-26t-55.5-65.5-68-97.5-53.5-121-23.5-138q0-220 127-344t351-124q62 0 126.5 21.5t120 58 95.5 68.5 76 68q36-36 76-68t95.5-68.5 120-58 126.5-21.5q224 0 351 124t127 344q0 221-229 450l-623 600q-18 18-44 18z" fill="currentColor"></path>' +
              '</svg>' +
              '</span>' +
              '</button>';

            // ========== COLOR SWATCHES (from all_swatches) ==========
            var colorSwatchesHtml = '';
            // Show swatches if all_swatches exists with at least 1 color
            if (hit.all_swatches && Array.isArray(hit.all_swatches) && hit.all_swatches.length > 0) {
              colorSwatchesHtml = '<div class="color-swatches">';
              hit.all_swatches.forEach(function (swatch) {
                var isActive = swatch.color === currentColor ? ' active' : '';
                var swatchImg = swatch.image && swatch.image.src ? swatch.image.src : '';
                var bgStyle = swatchImg ? 'background-image: url(' + swatchImg + ')' : 'background-color: ' + (swatch.color_hex || '#ccc');
                var swatchVariantId = swatch.variant_id || '';
                colorSwatchesHtml += '<button class="color-swatch' + isActive + '" data-color="' + swatch.color + '" data-variant-id="' + swatchVariantId + '" style="' + bgStyle + '" title="' + swatch.color + '" type="button"></button>';
              });
              colorSwatchesHtml += '</div>';
            }
            // If no swatches data, colorSwatchesHtml remains empty - no swatches shown

            // ========== IMAGE DISPLAY (from images_by_color with fallbacks) ==========
            var hasImagesByColor = hit.images_by_color && typeof hit.images_by_color === 'object' && Object.keys(hit.images_by_color).length > 0;
            var colorImages = [];

            // Try to get images for current color from images_by_color
            if (hasImagesByColor && currentColor && hit.images_by_color[currentColor]) {
              colorImages = hit.images_by_color[currentColor];
            }
            // Fallback to hit.images array
            else if (hit.images && Array.isArray(hit.images) && hit.images.length > 0) {
              colorImages = hit.images;
            }

            var imageHtml = '';

            // Get product position (1-indexed) - only first 8 products get eager loading and high fetch priority
            var productPosition = hit.__position || 999;
            var isAboveFold = productPosition <= 8;
            var loadingAttr = isAboveFold ? 'eager' : 'lazy';
            var fetchPriorityAttr = isAboveFold ? ' fetchpriority="high"' : '';

            // Case 1: Multiple images - lazy load carousel
            if (colorImages.length > 1) {
              // Get first image for initial display with responsive sizing
              var firstImgSrc = colorImages[0].src || '';

              // Prepare all images data for lazy carousel loading (store original URLs, resize on render)
              var carouselImages = colorImages.map(function (img) {
                return img.src || '';
              });

              // Store images and images_by_color for lazy loading
              var imagesDataAttr = ' data-carousel-images="' + encodeURIComponent(JSON.stringify(carouselImages)) + '"';
              if (hasImagesByColor) {
                imagesDataAttr += ' data-images-by-color="' + encodeURIComponent(JSON.stringify(hit.images_by_color)) + '"';
              }

              // Render only first image initially with responsive srcset, carousel loads on hover
              imageHtml = '<div class="product-image-container" data-has-carousel="true"' + imagesDataAttr + ' data-product-url="' + productUrl + '" data-product-title="' + productTitle.replace(/"/g, '&quot;') + '">';
              imageHtml += '<a href="' + productUrl + '">' + buildResponsiveImg(firstImgSrc, productTitle, 'product-img', loadingAttr, fetchPriorityAttr) + '</a>';
              imageHtml += '</div>';
            }
            // Case 2: Single image - no carousel needed
            else if (colorImages.length === 1) {
              var singleImgSrc = colorImages[0].src || '';
              imageHtml = '<a href="' + productUrl + '">' + buildResponsiveImg(singleImgSrc, productTitle, 'product-img', loadingAttr, fetchPriorityAttr) + '</a>';
            }
            // Case 3: No images - show placeholder image
            else {
              imageHtml = '<a href="' + productUrl + '"><img src="' + PLACEHOLDER_IMAGE + '" alt="' + productTitle + '" class="product-img" loading="' + loadingAttr + '"' + fetchPriorityAttr + ' /></a>';
            }

            return '<article class="product-card af-productCard" data-handle="' + (hit.handle || '') + '" data-current-color="' + currentColor + '">' +
              '<div class="product-card__image-wrapper">' +
              saleBadgeHtml +
              newBadgeHtml +
              wishlistHtml +
              imageHtml +
              '</div>' +
              '<div class="product-card__content">' +
              colorSwatchesHtml +
              '<h3 class="product-card__title"><a href="' + productUrl + '">' + productTitle + '</a></h3>' +
              '<div class="product-card__price">' + priceHtml + '</div>' +
              '</div>' +
              '</article>';
          },
          empty: function () {
            return '<div class="collection-empty">' +
              '<div class="collection-empty__icon">' +
              '<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<rect x="0.5" y="0.5" width="49" height="49" rx="24.5" stroke="#9A9A9A"></rect>' +
              '<path d="M18.125 28.625C17.4219 28.625 16.875 29.2109 16.875 29.875C16.875 30.5781 17.4219 31.125 18.125 31.125C18.7891 31.125 19.375 30.5781 19.375 29.875C19.375 29.2109 18.7891 28.625 18.125 28.625ZM21.0938 28.9375H34.0625C34.5703 28.9375 35 29.3672 35 29.875C35 30.4219 34.5703 30.8125 34.0625 30.8125H21.0938C20.7031 32.1016 19.4922 33 18.125 33C16.3672 33 15 31.6328 15 29.875C15 28.1562 16.3672 26.75 18.125 26.75C19.4922 26.75 20.7031 27.6875 21.0938 28.9375ZM30.625 21.125C30.625 21.8281 31.1719 22.375 31.875 22.375C32.5391 22.375 33.125 21.8281 33.125 21.125C33.125 20.4609 32.5391 19.875 31.875 19.875C31.1719 19.875 30.625 20.4609 30.625 21.125ZM28.8672 20.1875C29.2578 18.9375 30.4688 18 31.875 18C33.5938 18 35 19.4062 35 21.125C35 22.8828 33.5938 24.25 31.875 24.25C30.4688 24.25 29.2578 23.3516 28.8672 22.0625H15.9375C15.3906 22.0625 15 21.6719 15 21.125C15 20.6172 15.3906 20.1875 15.9375 20.1875H28.8672Z" fill="#9A9A9A"></path>' +
              '</svg>' +
              '</div>' +
              '<p class="collection-empty__text">' + config.translations.empty + '</p>' +
              '</div>';
          }
        },
        cssClasses: {
          list: 'ais-Hits-list',
          item: 'ais-Hits-item'
        }
      }),

      // Custom pagination - supports both numbered pages and "Load more" button
      instantsearch.connectors.connectPagination(function (renderOptions, isFirstRender) {
        var container = document.querySelector('#pagination');
        var currentRefinement = renderOptions.currentRefinement;
        var nbPages = renderOptions.nbPages;
        var nbHits = renderOptions.nbHits;
        var refine = renderOptions.refine;

        // Don't render if pagination is disabled
        if (!showPagination) {
          container.innerHTML = '';
          return;
        }

        // Don't render if no pages or no results yet
        if (!nbPages || nbPages <= 1 || nbHits === 0 || nbHits === undefined) {
          container.innerHTML = '';
          return;
        }

        var html = '';

        // Pagination type: "Load more" button
        if (paginationType === 'load_more') {
          // Only show load more if there are more pages
          if (currentRefinement < nbPages - 1) {
            var loadMoreLabels = {
              'en': 'Load more',
              'de': 'Mehr laden',
              'fr': 'Charger plus',
              'it': 'Carica altro'
            };
            var loadMoreText = loadMoreLabels[currentLocale] || loadMoreLabels['en'];

            html = '<div class="pagination__load-more">';
            html += '<button type="button" class="pagination__load-more-btn button button--secondary" data-page="' + (currentRefinement + 1) + '">' + loadMoreText + '</button>';
            html += '</div>';
          }

          container.innerHTML = html;

          // Add click handler for load more button
          var loadMoreBtn = container.querySelector('.pagination__load-more-btn');
          if (loadMoreBtn) {
            loadMoreBtn.addEventListener('click', function (e) {
              e.preventDefault();
              var page = parseInt(this.getAttribute('data-page'), 10);
              refine(page);
            });
          }
          return;
        }

        // Pagination type: Numbered pages (default)
        html = '<ul class="pagination__list list-unstyled">';

        // Pagination strategy: "1 2 3 4 ... last" format
        // Shows first 4 pages, ellipsis, and last page (when more than 5 pages)
        // When on later pages, shows context around current page
        var maxInitialPages = 4;

        if (nbPages <= 5) {
          // 5 or fewer pages: show all pages (no ellipsis needed)
          for (var i = 0; i < nbPages; i++) {
            var isCurrentPage = i === currentRefinement;
            var itemClass = 'pagination__item' + (isCurrentPage ? ' pagination__item--current' : '');
            html += '<li class="' + itemClass + '">';
            html += '<a href="#" class="pagination__link link" data-page="' + i + '">' + (i + 1) + '</a>';
            html += '</li>';
          }
        } else {
          // More than 5 pages: use "1 2 3 4 ... last" format with smart context
          var pagesToShow = [];

          if (currentRefinement <= 2) {
            // On pages 1-3: show first 4 pages + last page
            // e.g., "1 2 3 4 ... 9"
            for (var k = 0; k < maxInitialPages; k++) {
              pagesToShow.push(k);
            }
            pagesToShow.push(nbPages - 1);
          } else if (currentRefinement >= nbPages - 3) {
            // Near the end (last 3 pages): show first page + last 4 pages
            // e.g., "1 ... 6 7 8 9"
            pagesToShow.push(0);
            for (var m = nbPages - maxInitialPages; m < nbPages; m++) {
              pagesToShow.push(m);
            }
          } else {
            // In the middle: show first page + prev/current/next + last page
            // e.g., on page 5: "1 ... 4 5 6 ... 9"
            pagesToShow.push(0);
            pagesToShow.push(currentRefinement - 1);  // previous page
            pagesToShow.push(currentRefinement);       // current page
            pagesToShow.push(currentRefinement + 1);   // next page
            pagesToShow.push(nbPages - 1);
          }

          // Remove duplicates and sort
          pagesToShow = pagesToShow.filter(function (value, index, self) {
            return self.indexOf(value) === index;
          }).sort(function (a, b) { return a - b; });

          // Render with ellipsis where there are gaps
          var lastPage = -1;
          pagesToShow.forEach(function (pageNum) {
            // Add ellipsis if there's a gap
            if (lastPage !== -1 && pageNum > lastPage + 1) {
              html += '<li class="pagination__item pagination__item--ellipsis"><span class="pagination__ellipsis">...</span></li>';
            }

            var isCurrentPage = pageNum === currentRefinement;
            var itemClass = 'pagination__item' + (isCurrentPage ? ' pagination__item--current' : '');
            html += '<li class="' + itemClass + '">';
            html += '<a href="#" class="pagination__link link" data-page="' + pageNum + '">' + (pageNum + 1) + '</a>';
            html += '</li>';

            lastPage = pageNum;
          });
        }

        // Add next arrow if not on last page
        if (currentRefinement < nbPages - 1) {
          html += '<li class="pagination__item pagination__item--next">';
          html += '<a href="#" class="pagination__link link" data-page="' + (currentRefinement + 1) + '"><svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.26562 4.5L5.00781 4.78125L1.25781 8.53125L1 8.78906L0.460938 8.25L0.71875 7.99219L4.21094 4.5L0.71875 1.03125L0.460938 0.75L1 0.234375L1.25781 0.492188L5.00781 4.24219L5.26562 4.5Z" fill="currentColor"/></svg></a>';
          html += '</li>';
        }

        html += '</ul>';
        container.innerHTML = html;

        // Add click handlers
        container.querySelectorAll('a[data-page]').forEach(function (link) {
          link.addEventListener('click', function (e) {
            e.preventDefault();
            var page = parseInt(this.getAttribute('data-page'), 10);
            refine(page);
            // Scroll to top of product grid
            document.querySelector(containerPrefix).scrollIntoView({ behavior: 'smooth' });
          });
        });
      })({
        container: '#pagination'
      }),

      // Stats widget for "X von Y Produkten gesehen" - conditionally shown based on settings
      instantsearch.widgets.stats({
        container: '#pagination-stats',
        templates: {
          text: function (data, { html }) {
            // Don't show stats if disabled in settings
            if (!showPaginationStats) {
              return '';
            }

            var currentPage = data.page + 1;
            var hitsPerPage = data.hitsPerPage;
            var totalHits = data.nbHits;
            var seenProducts = Math.min(currentPage * hitsPerPage, totalHits);

            // Only show stats if there are more than 60 products (when pagination appears)
            if (totalHits === 0 || totalHits <= 60) {
              return '';
            }

            // Get localized template based on locale
            if (currentLocale === 'de') {
              return html`Du hast <strong>${seenProducts}</strong> von <strong>${totalHits}</strong> Produkten gesehen`;
            } else if (currentLocale === 'fr') {
              return html`Vous avez vu <strong>${seenProducts}</strong> sur <strong>${totalHits}</strong> produits`;
            } else if (currentLocale === 'it') {
              return html`Hai visto <strong>${seenProducts}</strong> di <strong>${totalHits}</strong> prodotti`;
            } else {
              return html`You have seen <strong>${seenProducts}</strong> of <strong>${totalHits}</strong> products`;
            }
          }
        }
      })
    ]);

    // Track if this is the first render (initial page load)
    var isFirstRender = true;
    var renderDebounceTimer = null;

    // Handle search errors - show friendly "no products" message instead of technical error
    search.on('error', function (error) {
      console.error('InstantSearch Error:', error);
      var hitsContainer = document.getElementById('hits');
      var skeletonLoader = document.getElementById('skeleton-loader');
      var filterSkeleton = document.getElementById('filter-skeleton');
      var mobileFilterSkeleton = document.getElementById('mobile-filter-skeleton');
      var desktopFilters = document.querySelector('.desktop-filter-sort');
      var mobileFilterBar = document.querySelector('.mobile-filter-sort-bar');

      if (hitsContainer) {
        // Show the same friendly empty state as when no products match
        hitsContainer.innerHTML = '<div class="collection-empty">' +
          '<div class="collection-empty__icon">' +
          '<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<rect x="0.5" y="0.5" width="49" height="49" rx="24.5" stroke="#9A9A9A"></rect>' +
          '<path d="M18.125 28.625C17.4219 28.625 16.875 29.2109 16.875 29.875C16.875 30.5781 17.4219 31.125 18.125 31.125C18.7891 31.125 19.375 30.5781 19.375 29.875C19.375 29.2109 18.7891 28.625 18.125 28.625ZM21.0938 28.9375H34.0625C34.5703 28.9375 35 29.3672 35 29.875C35 30.4219 34.5703 30.8125 34.0625 30.8125H21.0938C20.7031 32.1016 19.4922 33 18.125 33C16.3672 33 15 31.6328 15 29.875C15 28.1562 16.3672 26.75 18.125 26.75C19.4922 26.75 20.7031 27.6875 21.0938 28.9375ZM30.625 21.125C30.625 21.8281 31.1719 22.375 31.875 22.375C32.5391 22.375 33.125 21.8281 33.125 21.125C33.125 20.4609 32.5391 19.875 31.875 19.875C31.1719 19.875 30.625 20.4609 30.625 21.125ZM28.8672 20.1875C29.2578 18.9375 30.4688 18 31.875 18C33.5938 18 35 19.4062 35 21.125C35 22.8828 33.5938 24.25 31.875 24.25C30.4688 24.25 29.2578 23.3516 28.8672 22.0625H15.9375C15.3906 22.0625 15 21.6719 15 21.125C15 20.6172 15.3906 20.1875 15.9375 20.1875H28.8672Z" fill="#9A9A9A"></path>' +
          '</svg>' +
          '</div>' +
          '<p class="collection-empty__text">' + config.translations.empty + '</p>' +
          '</div>';
        hitsContainer.classList.add('is-loaded');
      }

      // Hide all skeletons on error
      if (skeletonLoader) {
        skeletonLoader.classList.add('is-hidden');
      }
      if (filterSkeleton) {
        filterSkeleton.classList.add('is-hidden');
      }
      if (mobileFilterSkeleton) {
        mobileFilterSkeleton.classList.add('is-hidden');
      }

      // Hide filter/sort sections since there's nothing to filter
      if (desktopFilters) {
        desktopFilters.style.display = 'none';
      }
      if (mobileFilterBar) {
        mobileFilterBar.style.display = 'none';
      }
    });

    // Only show skeleton on initial load, not on filter/sort changes
    search.on('search', function () {
      // Only show skeleton loader on initial load
      if (isFirstRender) {
        var skeletonLoader = document.getElementById('skeleton-loader');
        var hitsContainer = document.getElementById('hits');
        if (skeletonLoader && hitsContainer) {
          hitsContainer.classList.remove('is-loaded');
          skeletonLoader.classList.remove('is-hidden');
        }
      }
    });

    // Initialize Swiper after each render and hide loading overlay
    // OPTIMIZED: Debounce heavy operations, but update filters immediately
    search.on('render', function () {
      // Retrieve and print collections facet data
      if (search.helper && search.helper.lastResults) {
        var results = search.helper.lastResults;

        // Get collections.handle facet
        var handleFacet = results.facets.find(f => f.name === 'collections.handle');
        if (handleFacet) {
          console.log('Collections by handle:', handleFacet.data);
          // e.g. { "pants": 10, "denim": 5, "new-in": 8, ... }
        }
      }

      // Update applied filters IMMEDIATELY for instant feedback (no debounce)
      updateAppliedFilters();
      updateMobileApplyButton();

      // Clear any pending debounce for heavy operations
      if (renderDebounceTimer) {
        clearTimeout(renderDebounceTimer);
      }

      // Debounce only the heavy operations (Swiper, skeleton, etc.)
      renderDebounceTimer = setTimeout(function () {
        var hitsContainer = document.getElementById('hits');
        var products = hitsContainer ? hitsContainer.querySelectorAll('.product-card') : [];
        var productCount = products.length;

        // Check if empty state is rendered (no hits)
        var emptyState = hitsContainer ? hitsContainer.querySelector('.collection-empty') : null;
        var hasContent = productCount > 0 || emptyState;

        // Hide skeletons once products have rendered OR empty state is shown
        if (isFirstRender && hasContent) {
          var skeletonLoader = document.getElementById('skeleton-loader');
          var filterSkeleton = document.getElementById('filter-skeleton');
          var mobileFilterSkeleton = document.getElementById('mobile-filter-skeleton');
          var desktopFilters = document.querySelector('.desktop-filter-sort');
          var mobileFilterBar = document.querySelector('.mobile-filter-sort-bar');

          if (skeletonLoader) {
            skeletonLoader.classList.add('is-hidden');
          }

          if (filterSkeleton) {
            filterSkeleton.classList.add('is-hidden');
          }

          if (mobileFilterSkeleton) {
            mobileFilterSkeleton.classList.add('is-hidden');
          }

          // Hide loading overlay
          var loadingOverlay = document.getElementById('api-loading-overlay');
          if (loadingOverlay) {
            loadingOverlay.style.display = 'none';
          }

          // If no products (empty state), hide filter/sort sections entirely
          if (emptyState && productCount === 0) {
            if (desktopFilters) {
              desktopFilters.style.display = 'none';
            }
            if (mobileFilterBar) {
              mobileFilterBar.style.display = 'none';
            }
          } else {
            // Show filter/sort sections if products exist
            if (desktopFilters) {
              desktopFilters.classList.add('is-loaded');
            }
            if (mobileFilterBar) {
              mobileFilterBar.classList.add('is-loaded');
            }
            // Add filter dropdown headers only once (only if products exist)
            addFilterHeaders();
          }

          isFirstRender = false;
        }

        // Mark hits container as loaded when products are present or empty state is shown
        if (hitsContainer && hasContent) {
          hitsContainer.classList.add('is-loaded');
        }

        // Always reinitialize Swipers after render - InstantSearch replaces DOM elements
        // on each render, so we need to re-attach hover handlers to new elements.
        // initProductSwipers() already guards against re-initializing via [data-hover-init]
        initProductSwipers();
        initColorSwatchHandlers();
      }, 50); // 50ms debounce for heavy operations only
    });

    // ========== WISHLIST INITIALIZATION ==========
    function waitForWishlistInit() {
      // Check if the function is immediately available
      if (typeof window.aicoInitWishlistIcons === 'function') {
        try {
          setTimeout(() => {
            console.log('re-appending icons');
            window.aicoInitWishlistIcons();
          }, 5000);
        } catch (e) {
          console.error('[Wishlist] Error calling aicoInitWishlistIcons:', e);
        }
        return;
      }
    }

    // Function to reinitialize wishlist buttons after Algolia renders products
    function reinitWishlistButtons() {
      // Use NileWishlist module to reinitialize buttons
      if (typeof window.NileWishlist !== 'undefined' && typeof window.NileWishlist.initButtons === 'function') {
        window.NileWishlist.initButtons();
      }
    }

    // ========== SWIPER INITIALIZATION ==========
    // Build and initialize carousel on demand (hover)
    function buildCarousel(container) {
      if (!container || container.dataset.carouselBuilt === 'true') return;

      var imagesJson = container.dataset.carouselImages;
      if (!imagesJson) return;

      var images = JSON.parse(decodeURIComponent(imagesJson));
      if (!images || images.length < 2) return;

      var productUrl = container.dataset.productUrl || '#';
      var productTitle = container.dataset.productTitle || 'Product';

      // Build swiper HTML with responsive images
      var swiperHtml = '<div class="swiper product-swiper">';
      swiperHtml += '<div class="swiper-wrapper">';
      images.forEach(function (imgSrc, idx) {
        // First image eager (already loaded), rest lazy
        var loadingAttr = idx === 0 ? 'eager' : 'lazy';
        swiperHtml += '<div class="swiper-slide"><a href="' + productUrl + '">' + buildResponsiveImg(imgSrc, productTitle, 'product-img', loadingAttr, '') + '</a></div>';
      });
      swiperHtml += '</div>';
      swiperHtml += '<div class="swiper-button-prev"></div>';
      swiperHtml += '<div class="swiper-button-next"></div>';
      swiperHtml += '<div class="swiper-pagination"></div>';
      swiperHtml += '</div>';

      // Replace container content with swiper
      container.innerHTML = swiperHtml;
      container.dataset.carouselBuilt = 'true';

      // Initialize Swiper
      var swiperEl = container.querySelector('.product-swiper');
      if (swiperEl && typeof Swiper !== 'undefined') {
        new Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          watchSlidesProgress: true,
          navigation: {
            nextEl: swiperEl.querySelector('.swiper-button-next'),
            prevEl: swiperEl.querySelector('.swiper-button-prev'),
            disabledClass: 'swiper-button-disabled'
          },
          pagination: {
            el: swiperEl.querySelector('.swiper-pagination'),
            clickable: true,
            type: 'bullets'
          }
        });
      }
    }

    // Initialize hover handlers for lazy carousel loading
    function initProductSwipers() {
      if (typeof Swiper === 'undefined') {
        console.warn('Swiper not loaded yet, skipping initialization');
        return;
      }

      // Add hover listeners to containers with carousels
      document.querySelectorAll(containerPrefix + ' .product-image-container[data-has-carousel="true"]:not([data-hover-init])').forEach(function (container) {
        container.dataset.hoverInit = 'true';

        // Build carousel on mouseenter (hover)
        container.addEventListener('mouseenter', function () {
          buildCarousel(container);
        }, { once: true });

        // Also build on touchstart for mobile
        container.addEventListener('touchstart', function () {
          buildCarousel(container);
        }, { once: true, passive: true });
      });

      // Also initialize any already-built swipers (from color swatch changes etc)
      document.querySelectorAll(containerPrefix + ' .product-swiper:not(.swiper-initialized)').forEach(function (el) {
        var slides = el.querySelectorAll('.swiper-slide');
        if (slides.length > 1) {
          new Swiper(el, {
            slidesPerView: 1,
            spaceBetween: 0,
            watchSlidesProgress: true,
            navigation: {
              nextEl: el.querySelector('.swiper-button-next'),
              prevEl: el.querySelector('.swiper-button-prev'),
              disabledClass: 'swiper-button-disabled'
            },
            pagination: {
              el: el.querySelector('.swiper-pagination'),
              clickable: true,
              type: 'bullets'
            }
          });
        }
      });
    }

    // ========== COLOR SWATCH CLICK HANDLERS ==========
    function initColorSwatchHandlers() {
      // Use event delegation for better performance and to handle dynamically added elements
      var hitsContainer = document.getElementById('hits');
      if (!hitsContainer) return;

      // Remove previous handler if it exists (to prevent duplicates on re-render)
      if (hitsContainer._swatchHandler) {
        hitsContainer.removeEventListener('click', hitsContainer._swatchHandler);
      }

      hitsContainer._swatchHandler = function (e) {
        var swatch = e.target.closest('.color-swatch');
        if (!swatch) return;

        e.preventDefault();
        e.stopPropagation();

        var color = swatch.dataset.color;
        if (!color) return;

        var card = swatch.closest('.product-card');
        if (!card) return;

        var swiperEl = card.querySelector('.product-swiper');
        var imageContainer = card.querySelector('.product-image-container[data-has-carousel="true"]');

        // Update active swatch
        card.querySelectorAll('.color-swatch').forEach(function (s) {
          s.classList.remove('active');
        });
        swatch.classList.add('active');

        // Update card's current color data attribute
        card.dataset.currentColor = color;

        // Get images_by_color data from either swiper or image container
        var imagesDataAttr = (swiperEl && swiperEl.dataset.imagesByColor) ||
          (imageContainer && imageContainer.dataset.imagesByColor);

        if (imagesDataAttr) {
          try {
            var imagesData = JSON.parse(decodeURIComponent(imagesDataAttr));
            if (imagesData[color] && imagesData[color].length > 0) {
              var newImages = imagesData[color];
              var productTitle = card.querySelector('.product-card__title a')?.textContent || 'Product';

              // If swiper exists and is initialized, update its slides
              if (swiperEl && swiperEl.swiper) {
                updateSwiperImages(swiperEl.swiper, newImages, productTitle);
              }
              // If carousel not built yet, update the first image and carousel data
              else if (imageContainer) {
                var firstImgSrc = newImages[0].src || '';
                var imgAttrs = getResponsiveImageAttrs(firstImgSrc);

                // Update visible image with responsive attributes
                var img = imageContainer.querySelector('img');
                if (img) {
                  img.src = imgAttrs.src;
                  img.srcset = imgAttrs.srcset;
                  img.sizes = imgAttrs.sizes;
                  img.alt = productTitle;
                }
                // Update carousel data for when it's built on hover (store original URLs)
                var carouselImages = newImages.map(function (imgObj) {
                  return imgObj.src || '';
                });
                imageContainer.dataset.carouselImages = encodeURIComponent(JSON.stringify(carouselImages));
                // Reset carousel built flag so it rebuilds with new images on next hover
                imageContainer.dataset.carouselBuilt = 'false';
              }
            }
          } catch (err) {
            console.warn('Error parsing images_by_color data:', err);
          }
        }

        // Update product URLs with variant ID
        var handle = card.dataset.handle;
        var variantId = swatch.dataset.variantId;
        if (handle) {
          var newUrl = '/products/' + handle;
          // Use variant ID if available, otherwise fall back to color parameter
          if (variantId) {
            newUrl += '?variant=' + variantId;
          } else {
            newUrl += '?color=' + encodeURIComponent(color);
          }
          card.querySelectorAll('a').forEach(function (a) {
            // Only update product links, not external links
            if (a.href.includes('/products/')) {
              a.href = newUrl;
            }
          });
        }
      };

      hitsContainer.addEventListener('click', hitsContainer._swatchHandler);
    }

    // ========== HELPER: UPDATE SWIPER IMAGES ==========
    function updateSwiperImages(swiper, images, altText) {
      if (!swiper || !images || images.length === 0) return;

      // Get current product URL from first slide link
      var currentUrl = swiper.el.querySelector('a')?.href || '#';

      // Remove all existing slides
      swiper.removeAllSlides();

      // Add new slides for the selected color with responsive images
      images.forEach(function (img, idx) {
        var imgSrc = img.src || '';
        var slideHtml = '<div class="swiper-slide">' +
          '<a href="' + currentUrl + '">' +
          buildResponsiveImg(imgSrc, altText || 'Product', 'product-img', 'lazy', '') +
          '</a></div>';
        swiper.appendSlide(slideHtml);
      });

      // Reset to first slide
      swiper.slideTo(0, 0);
    }

    // Filter and Sort widget toggle functionality
    function initWidgetToggles() {
      document.querySelectorAll(containerPrefix + ' .filter-widget .filter-widget-toggle').forEach(function (widgetToggle) {
        // Remove existing listeners by cloning
        const newWidgetToggle = widgetToggle.cloneNode(true);
        widgetToggle.parentNode.replaceChild(newWidgetToggle, widgetToggle);

        newWidgetToggle.addEventListener('click', function (e) {
          e.stopPropagation();
          const widget = this.closest('.filter-widget');
          const isOpen = widget.classList.contains('is-open');

          // Close all other widgets
          document.querySelectorAll(containerPrefix + ' .filter-widget').forEach(function (w) {
            w.classList.remove('is-open');
          });

          // Toggle current widget
          if (!isOpen) {
            widget.classList.add('is-open');
          }
        });
      });
    }

    // ========== MOBILE FILTER DRAWER FUNCTIONALITY ==========

    // Store scroll position for body scroll lock
    var scrollPosition = 0;

    // Drag state for swipe-to-close
    var dragState = {
      isDragging: false,
      startY: 0,
      currentY: 0,
      drawerContent: null
    };

    // Open mobile filter drawer
    function openMobileFilterDrawer() {
      const drawer = document.getElementById('mobile-filter-drawer');
      const trigger = document.querySelector('.mobile-filter-trigger');
      if (!drawer) return;

      // Store scroll position and lock body scroll
      scrollPosition = window.pageYOffset;
      document.body.classList.add('mobile-filter-drawer-open');
      document.body.style.top = -scrollPosition + 'px';

      // Open drawer
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');

      // Update footer visibility based on current filter state
      var hasFilters = false;
      if (search && search.helper && search.helper.state.disjunctiveFacetsRefinements) {
        Object.values(search.helper.state.disjunctiveFacetsRefinements).forEach(function (values) {
          if (values && values.length > 0) {
            hasFilters = true;
          }
        });
      }
      // Directly show/hide footer in drawer using inline style
      var drawerFooter = drawer.querySelector('.mobile-filter-drawer__footer');
      if (drawerFooter) {
        drawerFooter.style.display = hasFilters ? 'flex' : 'none';
      }
    }

    // Close mobile filter drawer
    function closeMobileFilterDrawer() {
      const drawer = document.getElementById('mobile-filter-drawer');
      const trigger = document.querySelector('.mobile-filter-trigger');
      if (!drawer) return;

      // Hide the drawer footer when closing
      var drawerFooter = drawer.querySelector('.mobile-filter-drawer__footer');
      if (drawerFooter) {
        drawerFooter.style.display = 'none';
      }

      // Close drawer
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');

      // Restore body scroll
      document.body.classList.remove('mobile-filter-drawer-open');
      document.body.style.top = '';
      window.scrollTo(0, scrollPosition);
    }

    // Handle drag start on drawer handle
    function handleDragStart(e) {
      var drawer = document.getElementById('mobile-filter-drawer');
      if (!drawer || !drawer.classList.contains('is-open')) return;

      // Don't start drag if clicking on close button
      if (e.target.closest('.mobile-filter-drawer__close')) return;

      var clientY = e.type.indexOf('touch') !== -1 ? e.touches[0].clientY : e.clientY;

      dragState.isDragging = true;
      dragState.startY = clientY;
      dragState.currentY = clientY;
      dragState.drawerContent = document.querySelector('.mobile-filter-drawer__content');

      if (dragState.drawerContent) {
        // Disable transition during drag
        dragState.drawerContent.style.transition = 'none';
        dragState.drawerContent.style.willChange = 'transform';
      }
    }

    // Handle drag move
    function handleDragMove(e) {
      if (!dragState.isDragging || !dragState.drawerContent) return;

      var clientY = e.type.indexOf('touch') !== -1 ? e.touches[0].clientY : e.clientY;
      dragState.currentY = clientY;
      var deltaY = dragState.currentY - dragState.startY;

      // Only allow dragging down (positive deltaY)
      if (deltaY > 0) {
        dragState.drawerContent.style.transform = 'translateY(' + deltaY + 'px)';

        // Also fade the overlay as we drag
        var overlay = document.querySelector('.mobile-filter-drawer__overlay');
        if (overlay) {
          var opacity = Math.max(0, 1 - (deltaY / 300));
          overlay.style.opacity = opacity;
        }
      }
    }

    // Handle drag end
    function handleDragEnd(e) {
      if (!dragState.isDragging) return;

      var deltaY = dragState.currentY - dragState.startY;
      var drawerContent = dragState.drawerContent;
      var overlay = document.querySelector('.mobile-filter-drawer__overlay');

      // Reset drag state first
      dragState.isDragging = false;
      dragState.startY = 0;
      dragState.currentY = 0;
      dragState.drawerContent = null;

      if (!drawerContent) return;

      // Re-enable transition
      drawerContent.style.transition = '';
      drawerContent.style.willChange = '';

      // If dragged down more than 80px, close the drawer
      if (deltaY > 80) {
        // Reset transform and overlay before closing so drawer opens correctly next time
        drawerContent.style.transform = '';
        if (overlay) {
          overlay.style.opacity = '';
        }
        closeMobileFilterDrawer();
      } else {
        // Snap back
        drawerContent.style.transform = '';
        if (overlay) {
          overlay.style.opacity = '';
        }
      }
    }

    // Initialize mobile filter drawer
    function initMobileFilterDrawer() {
      var drawer = document.getElementById('mobile-filter-drawer');
      var trigger = document.querySelector('.mobile-filter-trigger');
      var closeBtn = document.querySelector('.mobile-filter-drawer__close');
      var overlay = document.querySelector('.mobile-filter-drawer__overlay');
      var handle = document.querySelector('.mobile-filter-drawer__handle');

      if (!drawer) return;

      // Open drawer on trigger click
      if (trigger) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          openMobileFilterDrawer();
        });
      }

      // Close drawer on close button click
      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          closeMobileFilterDrawer();
        });
      }

      // Close drawer on overlay click
      if (overlay) {
        overlay.addEventListener('click', function (e) {
          closeMobileFilterDrawer();
        });
      }

      // Drag to close on handle - use touchstart and mousedown
      if (handle) {
        handle.addEventListener('touchstart', handleDragStart, { passive: false });
        handle.addEventListener('mousedown', handleDragStart);
      }

      // Global move and end listeners (attached once)
      document.addEventListener('touchmove', handleDragMove, { passive: false });
      document.addEventListener('mousemove', handleDragMove);
      document.addEventListener('touchend', handleDragEnd);
      document.addEventListener('mouseup', handleDragEnd);
      document.addEventListener('touchcancel', handleDragEnd);

      // Close drawer on escape key
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
          closeMobileFilterDrawer();
        }
      });

      // Clear all button - clears all filters
      var clearButton = drawer.querySelector('.mobile-filter-drawer__clear');
      if (clearButton) {
        clearButton.addEventListener('click', function (e) {
          e.preventDefault();
          // Clear all refinements
          if (search && search.helper) {
            search.helper.clearRefinements().search();
          }
          // Immediately hide the footer since no filters will be selected
          var drawerFooter = drawer.querySelector('.mobile-filter-drawer__footer');
          if (drawerFooter) {
            drawerFooter.style.display = 'none';
          }
        });
      }

      // Apply button - closes the drawer
      var applyButton = drawer.querySelector('.mobile-filter-drawer__apply');
      if (applyButton) {
        applyButton.addEventListener('click', function (e) {
          e.preventDefault();
          closeMobileFilterDrawer();
        });
      }
    }

    // Initialize mobile filter accordions
    function initMobileFilterAccordions() {
      const accordions = document.querySelectorAll('.mobile-filter-accordion');

      accordions.forEach(function (accordion) {
        const trigger = accordion.querySelector('.mobile-filter-accordion__trigger');
        if (!trigger) return;

        // Remove existing listeners by cloning
        const newTrigger = trigger.cloneNode(true);
        trigger.parentNode.replaceChild(newTrigger, trigger);

        newTrigger.addEventListener('click', function (e) {
          e.preventDefault();
          const isOpen = accordion.classList.contains('is-open');

          // Toggle accordion
          if (isOpen) {
            accordion.classList.remove('is-open');
            newTrigger.setAttribute('aria-expanded', 'false');
          } else {
            accordion.classList.add('is-open');
            newTrigger.setAttribute('aria-expanded', 'true');
          }
        });
      });
    }

    // Add filter dropdown headers
    function addFilterHeaders() {
      const filterTitles = {
        'size-filter-widget': config.translations.sizeLabel,
        'color-filter-widget': config.translations.colorLabel,
        'material-filter-widget': materialLabel,
        'style-filter-widget': styleLabel
      };

      // Translated "Filter by" text
      const filterByText = {
        'en': 'Filter by',
        'de': 'Filtern nach',
        'fr': 'Filtrer par',
        'it': 'Filtra per'
      };
      const filterByLabel = filterByText[currentLocale] || filterByText['en'];

      // German-specific full dropdown labels (structure: "{Title} Filtern")
      const germanDropdownLabels = {
        'size-filter-widget': 'Grössen Filtern',
        'color-filter-widget': 'Farben Filtern',
        'material-filter-widget': 'Material Filtern',
        'style-filter-widget': 'Stil Filtern'
      };

      Object.keys(filterTitles).forEach(function (widgetId) {
        const widget = document.getElementById(widgetId);
        if (!widget) return;

        const refinementList = widget.querySelector('.ais-RefinementList');
        if (!refinementList || refinementList.querySelector('.filter-dropdown-header')) return;

        const title = filterTitles[widgetId];
        // Use German-specific labels for German locale, otherwise use standard format
        const dropdownTitle = (currentLocale === 'de' && germanDropdownLabels[widgetId])
          ? germanDropdownLabels[widgetId]
          : `${filterByLabel} ${title}`;
        const header = document.createElement('div');
        header.className = 'filter-dropdown-header';
        header.innerHTML = `
        <span class="filter-dropdown-title">${dropdownTitle}</span>
        <button class="filter-dropdown-close" aria-label="Close">
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.25 4.47412L8.85938 0.837402L9.48828 1.46631L5.85156 5.07568L9.48828 8.7124L8.85938 9.34131L5.25 5.70459L1.61328 9.34131L0.984375 8.7124L4.62109 5.07568L0.984375 1.46631L1.61328 0.837402L5.25 4.47412Z" fill="black"></path>
          </svg>
        </button>
      `;

        refinementList.insertBefore(header, refinementList.firstChild);

        // Close button functionality
        header.querySelector('.filter-dropdown-close').addEventListener('click', function (e) {
          e.stopPropagation();
          widget.classList.remove('is-open');
        });
      });
    }

    // Update mobile apply button with result count
    function updateMobileApplyButton() {
      var applyButton = document.querySelector('.mobile-filter-drawer__apply');
      if (!applyButton) return;

      var applyText = applyButton.querySelector('.mobile-filter-drawer__apply-text');
      if (!applyText) return;

      var template = applyText.getAttribute('data-template');
      if (!template) return;

      // Get the current result count from InstantSearch
      var nbHits = 0;
      if (search && search.helper && search.helper.lastResults) {
        nbHits = search.helper.lastResults.nbHits || 0;
      }

      // Update the button text with the count
      applyText.textContent = template.replace('{count}', nbHits);
    }

    // Cache DOM elements for updateAppliedFilters (queried once)
    var cachedElements = null;
    function getCachedElements() {
      if (!cachedElements) {
        cachedElements = {
          appliedFiltersContainer: document.getElementById('applied-filters'),
          appliedFiltersList: document.getElementById('applied-filters-list'),
          mobileAppliedFilters: document.getElementById('mobile-applied-filters'),
          mobileAppliedFiltersList: document.getElementById('mobile-applied-filters-list'),
          mobileTriggerBadge: document.querySelector('.mobile-filter-trigger__badge'),
          widgets: {
            'size_options': document.getElementById('size-filter-widget'),
            'color_hex': document.getElementById('color-filter-widget')
          },
          accordionIndicators: {}
        };
        cachedElements.widgets[materialAttribute] = document.getElementById('material-filter-widget');
        cachedElements.widgets[styleAttribute] = document.getElementById('style-filter-widget');
        // Cache accordion indicators
        ['size', 'color', 'material', 'style'].forEach(function (filter) {
          cachedElements.accordionIndicators[filter] = document.querySelector('.mobile-filter-accordion__indicator[data-filter="' + filter + '"]');
        });
      }
      return cachedElements;
    }

    // Pre-compute static label mappings (singular and plural forms)
    var filterLabelsSingular = {
      'size_options': { 'de': 'Grösse', 'fr': 'Taille', 'it': 'Taglia', 'en': 'Size' },
      'color_hex': { 'de': 'Farbe', 'fr': 'Couleur', 'it': 'Colore', 'en': 'Color' }
    };
    filterLabelsSingular[materialAttribute] = { 'de': 'Material', 'fr': 'Matière', 'it': 'Materiale', 'en': 'Material' };
    filterLabelsSingular[styleAttribute] = { 'de': 'Stil', 'fr': 'Style', 'it': 'Stile', 'en': 'Style' };

    var filterLabelsPlural = {
      'size_options': { 'de': 'Grössen', 'fr': 'Tailles', 'it': 'Taglie', 'en': 'Sizes' },
      'color_hex': { 'de': 'Farben', 'fr': 'Couleurs', 'it': 'Colori', 'en': 'Colors' }
    };
    filterLabelsPlural[materialAttribute] = { 'de': 'Materialien', 'fr': 'Matières', 'it': 'Materiali', 'en': 'Materials' };
    filterLabelsPlural[styleAttribute] = { 'de': 'Stile', 'fr': 'Styles', 'it': 'Stili', 'en': 'Styles' };

    // Helper function to get label based on count (singular vs plural)
    function getFilterLabel(attribute, count) {
      var labels = count === 1 ? filterLabelsSingular : filterLabelsPlural;
      var attrLabels = labels[attribute];
      if (attrLabels) {
        return attrLabels[currentLocale] || attrLabels['en'];
      }
      return attribute;
    }

    var attributeToAccordion = {
      'size_options': 'size',
      'color_hex': 'color'
    };
    attributeToAccordion[materialAttribute] = 'material';
    attributeToAccordion[styleAttribute] = 'style';

    // Use event delegation for filter tag removal (attached once)
    var filterRemoveHandlerAttached = false;
    function attachFilterRemoveHandler() {
      if (filterRemoveHandlerAttached) return;
      filterRemoveHandlerAttached = true;

      // Desktop - event delegation
      var desktopList = document.getElementById('applied-filters-list');
      if (desktopList) {
        desktopList.addEventListener('click', function (e) {
          var btn = e.target.closest('.applied-filter-tag-remove');
          if (!btn) return;
          e.stopPropagation();
          var attribute = btn.dataset.attribute;

          // Immediately hide the tag for instant feedback
          var tag = btn.closest('.applied-filter-tag');
          if (tag) tag.remove();

          // Hide container if no more tags
          var elements = getCachedElements();
          if (elements.appliedFiltersList && elements.appliedFiltersList.children.length === 0) {
            elements.appliedFiltersContainer.style.display = 'none';
          }

          var currentRefinements = search.helper.state.disjunctiveFacetsRefinements || {};
          var vals = currentRefinements[attribute] || [];
          vals.forEach(function (value) {
            search.helper.removeDisjunctiveFacetRefinement(attribute, value);
          });
          search.helper.search();
        });
      }

      // Mobile - event delegation
      var mobileList = document.getElementById('mobile-applied-filters-list');
      if (mobileList) {
        mobileList.addEventListener('click', function (e) {
          var btn = e.target.closest('.mobile-applied-filter-tag__remove');
          if (!btn) return;
          e.stopPropagation();
          var attribute = btn.dataset.attribute;

          // Immediately hide the tag for instant feedback
          var tag = btn.closest('.mobile-applied-filter-tag');
          if (tag) tag.remove();

          // Hide container if no more tags and update badge
          var elements = getCachedElements();
          if (elements.mobileAppliedFiltersList && elements.mobileAppliedFiltersList.children.length === 0) {
            elements.mobileAppliedFilters.style.display = 'none';
          }

          // Update mobile badge count immediately
          if (elements.mobileTriggerBadge) {
            var remainingCount = elements.mobileAppliedFiltersList ? elements.mobileAppliedFiltersList.children.length : 0;
            if (remainingCount > 0) {
              elements.mobileTriggerBadge.textContent = String(remainingCount);
            } else {
              elements.mobileTriggerBadge.style.display = 'none';
            }
          }

          var currentRefinements = search.helper.state.disjunctiveFacetsRefinements || {};
          var vals = currentRefinements[attribute] || [];
          vals.forEach(function (value) {
            search.helper.removeDisjunctiveFacetRefinement(attribute, value);
          });
          search.helper.search();
        });
      }
    }

    // Update applied filters display (desktop and mobile) - OPTIMIZED
    function updateAppliedFilters() {
      var elements = getCachedElements();
      attachFilterRemoveHandler();

      // Get current refinements from the search state
      var state = search.helper.state;
      var refinements = state.disjunctiveFacetsRefinements || {};

      var hasFilters = false;
      var totalFilterCount = 0;
      var desktopHtml = '';
      var mobileHtml = '';

      // Reset widget selection classes
      Object.keys(elements.widgets).forEach(function (attr) {
        var widget = elements.widgets[attr];
        if (widget) widget.classList.remove('has-selections');
      });

      // Reset accordion indicators
      Object.keys(elements.accordionIndicators).forEach(function (filter) {
        var indicator = elements.accordionIndicators[filter];
        if (indicator) {
          indicator.classList.remove('has-selections');
          indicator.textContent = '';
        }
      });

      // Build filter HTML
      var attributes = Object.keys(refinements);
      for (var i = 0; i < attributes.length; i++) {
        var attribute = attributes[i];
        var values = refinements[attribute];
        if (!values || values.length === 0) continue;

        // Skip collections.handle from applied filters
        if (attribute === 'collections.handle') continue;

        hasFilters = true;
        totalFilterCount += values.length;

        // Get singular or plural label based on number of values
        var label = getFilterLabel(attribute, values.length);
        var mobileLabel = label;

        // Convert color_hex values to their labels
        var displayValues = attribute === 'color_hex'
          ? values.map(getColorLabel)
          : values;
        var valuesText = displayValues.join(', ');

        // Add has-selections class to the desktop widget
        var widget = elements.widgets[attribute];
        if (widget) widget.classList.add('has-selections');

        // Desktop applied filter tag
        if (attribute === 'color_hex') {
          var desktopColorSwatchesHtml = '';
          for (var j = 0; j < values.length; j++) {
            desktopColorSwatchesHtml += '<span class="applied-filter-tag-color" style="background-color: ' + values[j] + ';"></span>';
          }
          desktopHtml += '<div class="applied-filter-tag" data-attribute="' + attribute + '">' +
            '<span class="applied-filter-tag-label">' + label + ':</span>' +
            desktopColorSwatchesHtml +
            '<button class="applied-filter-tag-remove" data-attribute="' + attribute + '" aria-label="Remove filter">&times;</button>' +
            '</div>';
        } else {
          desktopHtml += '<div class="applied-filter-tag" data-attribute="' + attribute + '">' +
            '<span class="applied-filter-tag-label">' + label + ':</span>' +
            '<span class="applied-filter-tag-values">' + valuesText + '</span>' +
            '<button class="applied-filter-tag-remove" data-attribute="' + attribute + '" aria-label="Remove filter">&times;</button>' +
            '</div>';
        }

        // Mobile applied filter tag
        if (attribute === 'color_hex') {
          var colorSwatchesHtml = '';
          for (var j = 0; j < values.length; j++) {
            colorSwatchesHtml += '<span class="mobile-applied-filter-tag__color" style="background-color: ' + values[j] + ';"></span>';
          }
          mobileHtml += '<div class="mobile-applied-filter-tag" data-attribute="' + attribute + '">' +
            '<span class="mobile-applied-filter-tag__content">' +
            '<span class="mobile-applied-filter-tag__label">' + mobileLabel + ':</span>' +
            colorSwatchesHtml +
            '</span>' +
            '<button class="mobile-applied-filter-tag__remove" data-attribute="' + attribute + '" aria-label="Remove">&times;</button>' +
            '</div>';
        } else {
          mobileHtml += '<div class="mobile-applied-filter-tag" data-attribute="' + attribute + '">' +
            '<span class="mobile-applied-filter-tag__content">' +
            '<span class="mobile-applied-filter-tag__label">' + mobileLabel + ':</span>' +
            '<span class="mobile-applied-filter-tag__values">' + valuesText + '</span>' +
            '</span>' +
            '<button class="mobile-applied-filter-tag__remove" data-attribute="' + attribute + '" aria-label="Remove">&times;</button>' +
            '</div>';
        }

        // Update accordion indicator
        var accordionFilter = attributeToAccordion[attribute];
        var indicator = elements.accordionIndicators[accordionFilter];
        if (indicator) {
          indicator.classList.add('has-selections');
          if (attribute === 'color_hex') {
            if (values.length <= 3) {
              var swatchHtml = '';
              for (var k = 0; k < values.length; k++) {
                swatchHtml += '<span class="mobile-filter-accordion__indicator-color" style="background-color: ' + values[k] + ';"></span>';
              }
              indicator.innerHTML = swatchHtml;
            } else {
              indicator.innerHTML = '<span class="mobile-filter-accordion__indicator-color" style="background-color: ' + values[0] + ';"></span>' +
                '<span class="mobile-filter-accordion__indicator-count">+' + (values.length - 1) + '</span>';
            }
          } else {
            indicator.innerHTML = '<span class="mobile-filter-accordion__indicator-count">' + values.length + '</span>';
          }
        }
      }

      // Update desktop applied filters
      if (elements.appliedFiltersContainer && elements.appliedFiltersList) {
        elements.appliedFiltersList.innerHTML = desktopHtml;
        elements.appliedFiltersContainer.style.display = hasFilters ? 'flex' : 'none';
      }

      // Update mobile applied filters
      if (elements.mobileAppliedFilters && elements.mobileAppliedFiltersList) {
        elements.mobileAppliedFiltersList.innerHTML = mobileHtml;
        elements.mobileAppliedFilters.style.display = hasFilters ? 'block' : 'none';
      }

      // Update mobile filter trigger badge
      if (elements.mobileTriggerBadge) {
        if (totalFilterCount > 0) {
          elements.mobileTriggerBadge.textContent = String(totalFilterCount);
          elements.mobileTriggerBadge.style.display = 'flex';
        } else {
          elements.mobileTriggerBadge.textContent = '0';
          elements.mobileTriggerBadge.style.display = 'none';
        }
      }

      // Update mobile filter drawer footer and action bar visibility
      updateMobileFilterActionBar(hasFilters);
    }

    // Update drawer footer visibility (inside modal)
    function updateMobileFilterActionBar(hasFilters) {
      var drawer = document.getElementById('mobile-filter-drawer');
      if (drawer && drawer.classList.contains('is-open')) {
        var drawerFooter = drawer.querySelector('.mobile-filter-drawer__footer');
        if (drawerFooter) {
          drawerFooter.style.display = hasFilters ? 'flex' : 'none';
        }

        // Update results count
        var resultsText = drawer.querySelector('.mobile-filter-drawer__apply-text');
        if (resultsText) {
          var template = resultsText.getAttribute('data-template');
          if (template) {
            var nbHits = 0;
            if (search && search.helper && search.helper.lastResults) {
              nbHits = search.helper.lastResults.nbHits || 0;
            }
            resultsText.textContent = template.replace('{count}', nbHits);
          }
        }
      }
    }

    // Initialize mobile filter action bar buttons
    function initMobileFilterActionBar() {
      var actionBar = document.getElementById('mobile-filter-action-bar');
      if (!actionBar) return;

      // Reset button
      var resetBtn = actionBar.querySelector('.mobile-filter-action-bar__reset');
      if (resetBtn) {
        resetBtn.addEventListener('click', function (e) {
          e.preventDefault();
          // Clear all refinements
          if (search && search.helper) {
            search.helper.clearRefinements().search();
          }
        });
      }

      // Show results button - scroll to top of products
      var resultsBtn = actionBar.querySelector('.mobile-filter-action-bar__results');
      if (resultsBtn) {
        resultsBtn.addEventListener('click', function (e) {
          e.preventDefault();
          // Scroll to top of product grid
          var productGrid = document.querySelector(containerPrefix);
          if (productGrid) {
            productGrid.scrollIntoView({ behavior: 'smooth' });
          }
        });
      }
    }

    // Initialize toggles
    initWidgetToggles();

    // Initialize mobile filter drawer and accordions
    initMobileFilterDrawer();
    initMobileFilterAccordions();

    // Initialize mobile filter action bar
    initMobileFilterActionBar();

    // Close widgets when clicking outside (but not on filter options)
    document.addEventListener('click', function (e) {
      // Don't close if clicking inside a refinement list or on a checkbox
      if (e.target.closest('.ais-RefinementList') ||
        e.target.closest('.ais-RefinementList-label') ||
        e.target.classList.contains('ais-RefinementList-checkbox')) {
        return;
      }

      if (!e.target.closest(containerPrefix + ' .filter-widget')) {
        document.querySelectorAll(containerPrefix + ' .filter-widget').forEach(function (w) {
          w.classList.remove('is-open');
        });
      }
    });

    // Start InstantSearch
    search.start();
    
    // For search pages: sync the existing Shopify search input with InstantSearch
    if (isSearchPage) {
      var shopifySearchInput = document.querySelector('#Search-In-Template');
      if (shopifySearchInput && search.helper) {
        // Debounce helper function
        var searchDebounceTimer = null;
        var SEARCH_DEBOUNCE_MS = 300;
        
        function debouncedSearch(query) {
          if (searchDebounceTimer) {
            clearTimeout(searchDebounceTimer);
          }
          searchDebounceTimer = setTimeout(function() {
            search.helper.setQuery(query).search();
          }, SEARCH_DEBOUNCE_MS);
        }
        
        // Listen for input changes on the Shopify search field (debounced)
        shopifySearchInput.addEventListener('input', function(e) {
          var newQuery = e.target.value;
          debouncedSearch(newQuery);
        });
        
        // Listen for form submit to trigger search (immediate, no debounce)
        var searchForm = shopifySearchInput.closest('form');
        if (searchForm) {
          searchForm.addEventListener('submit', function(e) {
            e.preventDefault();
            // Clear any pending debounced search
            if (searchDebounceTimer) {
              clearTimeout(searchDebounceTimer);
            }
            var newQuery = shopifySearchInput.value;
            search.helper.setQuery(newQuery).search();
            // Update URL with new query
            var url = new URL(window.location);
            url.searchParams.set('q', newQuery);
            window.history.pushState({}, '', url);
          });
        }
        
        // Sync InstantSearch query back to input when it changes (e.g., from URL)
        search.on('render', function() {
          if (search.helper && search.helper.state) {
            var currentQuery = search.helper.state.query || '';
            if (shopifySearchInput.value !== currentQuery) {
              shopifySearchInput.value = currentQuery;
            }
          }
        });
      }
    }

  } // End of startSearch function

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInstantSearch);
  } else {
    initInstantSearch();
  }

})();
